var zde = zde || {}; zde["modules"] = zde["modules"] || {}; zde["modules"]["reviews"] =
webpackJsonpzde_modules__name_([12],{

/***/ "+KrN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_knockout__ = __webpack_require__("7fPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_reviewitem__ = __webpack_require__("/ryK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_reviewcomment__ = __webpack_require__("R7O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_reviewlist__ = __webpack_require__("otQ7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__model_reviewitemmobile__ = __webpack_require__("FZjg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__model_reviewlistmobile__ = __webpack_require__("cK6l");







__WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.components.register('review-list', {
	viewModel: {
		createViewModel: function createViewModel(params) {
			return params instanceof __WEBPACK_IMPORTED_MODULE_3__model_reviewlist__["a" /* ReviewList */] ? params : new __WEBPACK_IMPORTED_MODULE_3__model_reviewlist__["a" /* ReviewList */](params);
		}
	},
	template: __webpack_require__("Vmcm")
});

__WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.components.register('review-item', {
	viewModel: {
		createViewModel: function createViewModel(params) {
			return params instanceof __WEBPACK_IMPORTED_MODULE_1__model_reviewitem__["a" /* ReviewItem */] ? params : new __WEBPACK_IMPORTED_MODULE_1__model_reviewitem__["a" /* ReviewItem */](params);
		}
	},
	template: __webpack_require__("QQLA")
});

__WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.components.register('review-comment', {
	viewModel: {
		createViewModel: function createViewModel(params) {
			return params instanceof __WEBPACK_IMPORTED_MODULE_2__model_reviewcomment__["a" /* ReviewComment */] ? params : new __WEBPACK_IMPORTED_MODULE_2__model_reviewcomment__["a" /* ReviewComment */](params);
		}
	},
	template: __webpack_require__("FA3v")
});

__WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.components.register('review-list-mobile', {
	viewModel: {
		createViewModel: function createViewModel(params) {
			return params instanceof __WEBPACK_IMPORTED_MODULE_5__model_reviewlistmobile__["a" /* ReviewListMobile */] ? params : new __WEBPACK_IMPORTED_MODULE_5__model_reviewlistmobile__["a" /* ReviewListMobile */](params);
		}
	},
	template: __webpack_require__("qQ5b")
});

__WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.components.register('review-item-mobile', {
	viewModel: {
		createViewModel: function createViewModel(params) {
			return params instanceof __WEBPACK_IMPORTED_MODULE_4__model_reviewitemmobile__["a" /* ReviewItemMobile */] ? params : new __WEBPACK_IMPORTED_MODULE_4__model_reviewitemmobile__["a" /* ReviewItemMobile */](params);
		}
	},
	template: __webpack_require__("/+4D")
});

/***/ }),

/***/ "/+4D":
/***/ (function(module, exports) {

module.exports = "<!-- ko if: showImage -->\r\n<a class=\"left\" href=\"\" data-bind=\"attr: {href: data().url}\">\r\n    <div class=\"img\" data-bind=\"style: {backgroundImage: 'url(\\'' + data().preview + '\\')'}\"></div>\r\n    <div class=\"activity\">\r\n        <!-- ko with: likers -->\r\n        <div class=\"likes\" title=\"Количество лайков\" data-bind=\"click: toggleMyLike\">\r\n            <span data-bind=\"text: likesCount\"></span>\r\n        </div>\r\n        <!-- /ko -->\r\n        <div class=\"comments\" title=\"Количество комментариев\">\r\n            <span data-bind=\"text: data().comments_count\"></span>\r\n        </div>\r\n    </div>\r\n</a>\r\n<!-- /ko -->\r\n\r\n<div class=\"right\">\r\n    <!-- ko if: showVideo && data().is_video -->\r\n        <!-- ko if: isDetailsPage -->\r\n        <div class=\"video-wrapper\">\r\n            <iframe\r\n                data-bind=\"attr: { src: getVideoUrl() }\"\r\n                frameborder=\"0\"\r\n                allowfullscreen\r\n                class=\"video-content\"\r\n            >\r\n            </iframe>\r\n        </div>\r\n        <!-- /ko -->\r\n        <!-- ko else -->\r\n        <a href=\"\" data-bind=\"attr: {href: data().url}\">\r\n            <img class=\"video-preview\" src=\"\" data-bind=\"attr: { src: data().preview, alt: data().title }\" />\r\n        </a>\r\n        <!-- /ko -->\r\n    <!-- /ko -->\r\n    <a href=\"\" class=\"title\" target=\"_blank\" data-bind=\"attr: {\r\n            href: titleUrl,\r\n            target: data().is_question ? '_self' : '_blank',\r\n            title: data().title\r\n        },\r\n        text: data().title\"></a>\r\n    <!-- ko with: data().our_info -->\r\n    <a href=\"\" class=\"title\" target=\"_blank\" data-bind=\"attr: {href: link, title: product_name}, text: product_name\"></a>\r\n    <!-- /ko -->\r\n    <div class=\"info\" data-bind=\"click: handleClick\">\r\n        <!-- ko if: !data().is_question -->\r\n\r\n        <!-- ko with: data -->\r\n        <!-- ko if: price -->\r\n        <div class=\"price\" title=\"Цена товара\" data-bind=\"text: price + ' &euro;'\"></div>\r\n        <!-- /ko -->\r\n        <div class=\"shop\">\r\n            <a href=\"#\" title=\"Магазин\" data-bind=\"attr: {href: shop_url}, text: shop_name\"></a>\r\n        </div>\r\n        <div class=\"rating rate-stars\" title=\"Рейтинг\" data-bind=\"visible: rating, css: 'rate-stars-' + rating\"></div>\r\n        <!-- /ko -->\r\n\r\n        <!-- /ko -->\r\n    </div>\r\n    <div class=\"content\" data-bind=\"click: handleClick\">\r\n        <span class=\"author\">\r\n            <a href=\"\" title=\"Автор\" data-bind=\"text: author.blogName, attr: {href: author.url}\"></a>\r\n        </span>\r\n        <!-- ko if: !isBodyLess() -->\r\n        <a class=\"text\" data-bind=\"attr: {href: data().url}, css: {collapsed: !opened()}\">\r\n            <div class=\"text-inner\" data-bind=\"html: displayHtml\"> </div>\r\n        </a>\r\n        <!-- /ko -->\r\n    </div>\r\n</div>\r\n<div class=\"review-dropdown\">\r\n    <div class=\"dropdown-content\">\r\n        <div class=\"content-inner\">\r\n            <!-- ko if: comments.length -->\r\n            <div class=\"more-comments\" data-bind=\"click: handleClick, visible: data().more_comments_count > 0\">\r\n                <a href=\"\" target=\"_blank\" data-bind=\"attr: {href: data().url}\">\r\n                    Ещё <span data-bind=\"text: data().more_comments_count_text\"></span>\r\n                </a>\r\n            </div>\r\n            <div class=\"comments-wrapper\" data-bind=\"click: handleClick, foreach: {data: comments, afterRender: afterCommentRender}\">\r\n                <div class=\"comment\">\r\n                    <div class=\"user-name\" data-bind=\"text: author.blogName\"></div>\r\n                    <div class=\"comment-text\" data-bind=\"html: displayHtml\"></div>\r\n                    <div class=\"activity\">\r\n                        <!-- ko with: likers -->\r\n                        <div class=\"likes\" title=\"Количество лайков\" data-bind=\"click: toggleMyLike\">\r\n                            <span data-bind=\"text: likesCount\"></span>\r\n                        </div>\r\n                        <!-- /ko -->\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <!-- /ko -->\r\n            <!-- ko else -->\r\n                <div class=\"no-comments\">\r\n                    <!-- ko if: data().is_question -->\r\n                    Нет ответов\r\n                    <!-- /ko -->\r\n                    <!-- ko else: -->\r\n                    Нет комментариев\r\n                    <!-- /ko -->\r\n                </div>\r\n            <!-- /ko -->\r\n            <!-- ko if: !isClosed() -->\r\n            <div class=\"add-comment-wrap\" data-bind=\"with: newComment\">\r\n                <form method=\"post\" data-bind=\"submit: save\">\r\n                    <textarea rows=\"1\" placeholder=\"Введите свой комментарий\"\r\n                        data-bind=\"textInput: text, autosize: {deferInit: true}, hasFocus: inputHasFocus\"></textarea>\r\n                    <button class=\"add-comment-button\" type=\"submit\" data-bind=\"visible: isSaveButtonVisible\">Отправить</button>\r\n                </form>\r\n            </div>\r\n            <!-- /ko -->\r\n        </div>\r\n    </div>\r\n    <div class=\"dropdown-header more-button\" data-bind=\"css: {opened: opened}, click: toggleDetails\">\r\n        <span>Подробнее</span>\r\n    </div>\r\n</div>"

/***/ }),

/***/ "/ryK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReviewItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("0iPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_autosize__ = __webpack_require__("E27B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reviewlist__ = __webpack_require__("otQ7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__likers__ = __webpack_require__("HNTF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reviewcomment__ = __webpack_require__("R7O4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_auth__ = __webpack_require__("UpRQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_widgets_notifier__ = __webpack_require__("2uje");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_utils_url__ = __webpack_require__("FYi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__core_utils_lang__ = __webpack_require__("RaK1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__core_modals__ = __webpack_require__("YdFU");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }














var ReviewItem = function () {
	function ReviewItem(data) {
		var _this = this;

		_classCallCheck(this, ReviewItem);

		this._parent = null;

		this.data = ko.observable(data);
		this._parent = data.parent;
		this._showImage = this._parent.showImages;
		this._showVideo = this._parent.showVideos;
		this._author = new __WEBPACK_IMPORTED_MODULE_6_core_auth__["UserInfo"](data.author);
		this._comments = ko.observableArray(data.comments ? __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.map(data.comments, function (d) {
			d.parent = _this;return new __WEBPACK_IMPORTED_MODULE_5__reviewcomment__["a" /* ReviewComment */](d);
		}) : []);
		this._newComment = new NewComment(this, function (comment) {
			_this._comments.push(comment);
		});
		this._likers = new __WEBPACK_IMPORTED_MODULE_4__likers__["a" /* Likers */](this.id, data.likes, data.my_like, data.is_sale ? __WEBPACK_IMPORTED_MODULE_4__likers__["d" /* TYPE_SALE_LIKE */] : __WEBPACK_IMPORTED_MODULE_4__likers__["c" /* TYPE_REVIEW_LIKE */]);
		this._onClick = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.Callbacks();

		this.collapsed = ko.observable(this._showImage);
		this.titleUrl = ko.pureComputed(function () {
			return _this._parent.isDetails ? null : _this.data().is_question ? _this.data().url : _this.data().package_info.order_id;
		});
		this.displayHtml = ko.pureComputed(function () {
			return Object(__WEBPACK_IMPORTED_MODULE_8_core_utils_url__["d" /* highlightUrls */])(_this.data().text);
		});
		this.isBodyLess = ko.pureComputed(function () {
			return !_this.data().text;
		});
		this.isClosed = ko.observable(data.closed);
		this.isAuthorHidden = !this._showImage && data.author.id === 1084; // Hide author if it is Alena

		this.handleClick = this.handleClick.bind(this);
		this.afterRender = this.afterRender.bind(this);

		if (zde.currentUser !== null && zde.currentUser.roleId == 2) {
			this._forWhom = ko.observable(data.for_whom);
			this.forWhomTitle = ko.pureComputed(function () {
				var result = void 0;
				switch (parseInt(_this._forWhom())) {
					case 1:
						result = 'Виден всем';
						break;
					case 2:
						result = 'Украина';
						break;
					case 3:
						result = 'Россия';
						break;
					case 4:
						result = 'Только участники';
						break;
					default:
						result = 'Виден всем';
						break;
				}
				return result;
			});

			this.isClosed.subscribe(function () {
				return _this.changeClosed();
			});
		}
	}
	/** @var {ReviewList} */


	_createClass(ReviewItem, [{
		key: 'getVideoUrl',


		/** @return string|null */
		value: function getVideoUrl() {
			var autoplay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

			var url = this.data().video_url;
			if (url && autoplay) {
				url += '?autoplay=1';
			}
			return url;
		}
	}, {
		key: 'handleClick',
		value: function handleClick(data, e) {
			var $target = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(e.target);
			var $currentTarget = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(e.currentTarget);

			if (this.data().is_sale) {
				// Allow default browser action
				return true;
			}

			if (($target.is('a') || $currentTarget.hasClass('direct-link')) && !$target.hasClass('review-text-wrapper')) {
				// Allow default browser action
				return true;
			}

			this._onClick.fireWith(this, [this]);
			return false;
		}
	}, {
		key: 'afterRender',
		value: function afterRender(anchor) {
			if (!this.showImage) {
				var $element = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(anchor).parents('.review-item');
				var $userInfo = $element.find('.review-header .user-info');
				var $likeButton = $element.find('.review-main .review-like');

				var $inlineContainer = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<div class="inline-container"></div>');

				$userInfo.addClass('user-info-inline');
				$likeButton.addClass('review-like-inline');
				$inlineContainer.append($userInfo).append($likeButton);
				if (this.isBodyLess()) {
					$element.find('.question-info-block .question-title').append($inlineContainer);
				} else {
					$element.find('.review-text').append($inlineContainer);
				}
			}
		}
	}, {
		key: 'onClick',
		value: function onClick(handler) {
			this._onClick.add(handler);
		}
	}, {
		key: 'offClick',
		value: function offClick(handler) {
			this._onClick.remove(handler);
		}
	}, {
		key: 'expand',
		value: function expand() {
			this.collapsed(false);
		}
	}, {
		key: 'remove',
		value: function remove() {
			if (confirm('Вы действительно хотите удалить отзыв?')) {
				this._parent.deleteItem(this);
			}
		}
	}, {
		key: 'edit',
		value: function edit() {
			var _this2 = this;

			if (this.data().is_question) {
				__WEBPACK_IMPORTED_MODULE_10__core_modals__["MODAL_QUESTION_EDIT"].show(this.id, function (response) {
					if (response && response.updatedValues) {
						var data = _this2.data();

						data.title = response.updatedValues.product_name;
						data.text = response.updatedValues.text;
						data.category_id = parseInt(response.updatedValues.category_id);
						if (response.updatedValues.date) {
							data.date = response.updatedValues.date;
							data.date_human = response.updatedValues.date_human;
						}

						_this2.data(data);

						if (!_this2.showImage) {
							_this2._forceRedraw();
						}
					}
				});
			} else {
				__WEBPACK_IMPORTED_MODULE_10__core_modals__["MODAL_REVIEW_EDIT"].show(this.id, null, {}, function (response) {
					if (response && response.updatedValues) {
						var data = _this2.data();

						if (response.updatedValues.product_name) {
							data.title = response.updatedValues.product_name;
						}
						data.text = response.updatedValues.text;
						data.category_id = parseInt(response.updatedValues.category_id);
						data.forsale = parseInt(response.updatedValues.forsale);
						data.rating = parseInt(response.updatedValues.rating);
						if (response.updatedValues.image_preview) {
							data.preview = response.updatedValues.image_preview;
						}

						_this2.data(data);

						if (!_this2.showImage) {
							_this2._forceRedraw();
						}
					}
				});
			}
		}
	}, {
		key: 'changeForWhom',
		value: function changeForWhom() {
			var _this3 = this;

			__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_8_core_utils_url__["g" /* siteUrl */])('reviews/changeForWhom'), {
				id: this.id,
				state: this._forWhom()
			}, function (response) {
				if (response.success) {
					_this3._forWhom(response.state);
				}
			}, 'json');
		}
	}, {
		key: 'changeClosed',
		value: function changeClosed() {
			__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_8_core_utils_url__["g" /* siteUrl */])('reviews/changeClosed'), {
				id: this.id,
				state: this.isClosed() ? 1 : 0
			}, function (response) {}, 'json');
		}

		/** @param {ReviewComment} comment */

	}, {
		key: 'deleteComment',
		value: function deleteComment(comment) {
			var _this4 = this;

			__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_8_core_utils_url__["g" /* siteUrl */])('reviews/delete_comment'), { id: comment.id }, function (response) {
				if (response.success) {
					_this4._comments.remove(comment);
				} else {
					__WEBPACK_IMPORTED_MODULE_7_core_widgets_notifier__["a" /* Notifier */].error();
				}
			}, 'json');
		}
	}, {
		key: '_forceRedraw',
		value: function _forceRedraw() {
			this._parent.reviews.replace(this, new ReviewItem(this.data()));
		}
	}, {
		key: 'id',
		get: function get() {
			return this.data().id;
		}

		/** @return {UserInfo} */

	}, {
		key: 'author',
		get: function get() {
			return this._author;
		}

		/** @return {ReviewComment[]} */

	}, {
		key: 'comments',
		get: function get() {
			return this._comments();
		}

		/** @return {NewComment} */

	}, {
		key: 'newComment',
		get: function get() {
			return this._newComment;
		}

		/** @return {Likers} */

	}, {
		key: 'likers',
		get: function get() {
			return this._likers;
		}

		/** @return {boolean} */

	}, {
		key: 'showImage',
		get: function get() {
			return this._showImage;
		}

		/** @return {boolean} */

	}, {
		key: 'showVideo',
		get: function get() {
			return this._showVideo;
		}

		/** @return {boolean} */

	}, {
		key: 'isDetailsPage',
		get: function get() {
			return this._parent.isDetails;
		}
	}]);

	return ReviewItem;
}();

var NewComment = function () {
	function NewComment(review, callback) {
		var _this5 = this;

		_classCallCheck(this, NewComment);

		this.text = ko.observable('');
		this.inputHasFocus = ko.observable(false);
		this.isSaveButtonVisible = null;

		this._review = review;
		this._textTrimmed = this.text.trimmed();
		this._onSave = __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.Callbacks();
		if (callback) {
			this._onSave.add(callback);
		}
		this.isSaveButtonVisible = ko.computed(function () {
			// return this.inputHasFocus() && this.text();
			return _this5._textTrimmed().length > 0;
		});
	}

	_createClass(NewComment, [{
		key: 'save',
		value: function save() {
			var _this6 = this;

			if (!this._textTrimmed().length) {
				return;
			}
			Object(__WEBPACK_IMPORTED_MODULE_6_core_auth__["ensureLoggedIn"])(function (user) {
				var parentId = _this6._review.id;
				var text = _this6._textTrimmed();
				var postData = void 0;

				_this6.text('');
				if (!_this6._review.data().is_sale) {
					postData = {
						text: text,
						parent_id: parentId,
						comment_type: 'review'
					};
					__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_8_core_utils_url__["g" /* siteUrl */])('reviews/save_comment'), postData, null, 'json').fail(__WEBPACK_IMPORTED_MODULE_7_core_widgets_notifier__["a" /* Notifier */].errorXHR).done(function (response) {
						if (!response || !response.success) {
							__WEBPACK_IMPORTED_MODULE_7_core_widgets_notifier__["a" /* Notifier */].error(response ? response.error : null);
						} else {
							var comment = new __WEBPACK_IMPORTED_MODULE_5__reviewcomment__["a" /* ReviewComment */]({
								id: response.id,
								text: text,
								author: user,
								date: response.date,
								date_human: response.date_human,
								likes: 0,
								my_like: false,
								is_editable: true,
								parent: _this6._review
							});
							_this6._onSave.fire(comment);
							__WEBPACK_IMPORTED_MODULE_7_core_widgets_notifier__["a" /* Notifier */].success("Комментарий отправлен");
						}
					});
				} else {
					postData = {
						comments_page_id: parentId,
						comments_content: text
					};
					__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_8_core_utils_url__["g" /* siteUrl */])('blog/comments_save'), postData, null, 'json').fail(__WEBPACK_IMPORTED_MODULE_7_core_widgets_notifier__["a" /* Notifier */].errorXHR).done(function (response) {
						if (!response || !response.success) {
							__WEBPACK_IMPORTED_MODULE_7_core_widgets_notifier__["a" /* Notifier */].error(response ? response.error : null);
						} else {
							var comment = new __WEBPACK_IMPORTED_MODULE_5__reviewcomment__["a" /* ReviewComment */]({
								id: response.comment.comments_id,
								text: text,
								author: user,
								date: response.comment.comments_date,
								date_human: response.comment.comments_date_human,
								likes: null,
								my_like: false,
								is_editable: false,
								parent: _this6._review
							});
							_this6._onSave.fire(comment);
							__WEBPACK_IMPORTED_MODULE_7_core_widgets_notifier__["a" /* Notifier */].success("Комментарий отправлен");
						}
					});
				}
			});
		}
	}, {
		key: 'onSave',
		value: function onSave(callback) {
			this._onSave.add(callback);
		}
	}]);

	return NewComment;
}();

/***/ }),

/***/ "0iPh":
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Y/PR");
module.exports = __webpack_require__("FCHk");


/***/ }),

/***/ "2uje":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Notifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_toastr__ = __webpack_require__("og09");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__("YnTO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_var__ = __webpack_require__("dTkA");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var t = Object(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["b" /* checkIsIframe */])() ? window.top.toastr : __WEBPACK_IMPORTED_MODULE_0_lib_toastr___default.a;

var MSG_ERROR = 'Ошибка';
var MSG_ERROR_XHR = 'Не удалось выполнить запрос';

var Notifier = function () {
	function Notifier() {
		_classCallCheck(this, Notifier);
	}

	_createClass(Notifier, null, [{
		key: "error",
		value: function error() {
			var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
			var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			// Extend timeout for errors to 10 seconds by default
			var timeOut = options ? Object(__WEBPACK_IMPORTED_MODULE_2__utils_var__["g" /* orDefault */])(options.timeOut, 10000) : 10000;
			t.error(Object(__WEBPACK_IMPORTED_MODULE_2__utils_var__["g" /* orDefault */])(message, MSG_ERROR), title, _extends({ timeOut: timeOut }, options));
		}
	}, {
		key: "errorXHR",
		value: function errorXHR(jqXHR, textStatus, errorThrown) {
			if (textStatus != 'abort') {
				Notifier.error(MSG_ERROR_XHR);
			}
		}
	}, {
		key: "info",
		value: function info(message) {
			var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			t.info(message, title, _extends({}, options));
		}
	}, {
		key: "success",
		value: function success(message) {
			var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			t.success(message, title, _extends({}, options));
		}
	}, {
		key: "warning",
		value: function warning(message) {
			var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			t.warning(message, title, _extends({}, options));
		}
	}]);

	return Notifier;
}();

/***/ }),

/***/ "49+S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GlobalEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_framebus__ = __webpack_require__("Oe2b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_framebus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_framebus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__("5wqq");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




/**
 * System-wide event class
 */
var GlobalEvent = function () {
	/**
  * Event constructor
  * @param {string} name Event name
  */
	function GlobalEvent(name) {
		_classCallCheck(this, GlobalEvent);

		this._name = name;
	}

	/**
  * Trigger this event
  * @param data The data to give to subscribers
  */


	_createClass(GlobalEvent, [{
		key: 'trigger',
		value: function trigger() {
			var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

			Object(__WEBPACK_IMPORTED_MODULE_1__logger__["a" /* newLogger */])(this.toString()).log('trigger', data);
			__WEBPACK_IMPORTED_MODULE_0_framebus__["trigger"](this._name, data);
		}

		/**
   * Subscribe to this event
   * @param {function} handler Function that accepts event data as first argument
   * @return {Subscription}
   */

	}, {
		key: 'on',
		value: function on(handler) {
			return this._getSubscription(handler).on();
		}

		/**
   * Unsubscribe from this event
   * @param {function} handler The same function that was passed to {@link on} method
   */

	}, {
		key: 'off',
		value: function off(handler) {
			this._getSubscription(handler).off();
		}
	}, {
		key: 'toString',
		value: function toString() {
			return 'GlobalEvent/' + this._name;
		}

		/**
   * Creates subscription instance. To actually subscribe, call on() method.
   * @param {function} handler Function that accepts event data as first argument
   * @return {Subscription}
   */

	}, {
		key: '_getSubscription',
		value: function _getSubscription(handler) {
			return new Subscription(this._name, handler);
		}
	}]);

	return GlobalEvent;
}();

var Subscription = function () {
	function Subscription(name, handler) {
		_classCallCheck(this, Subscription);

		this._name = name;
		this._handler = handler;
	}

	/**
  * Attach the subscription to bus
  * @return {Subscription} This instance
  */


	_createClass(Subscription, [{
		key: 'on',
		value: function on() {
			__WEBPACK_IMPORTED_MODULE_0_framebus__["on"](this._name, this._handler);
			return this;
		}

		/**
   * Cancel this subscription
   * @return {Subscription} This instance
   */

	}, {
		key: 'off',
		value: function off() {
			__WEBPACK_IMPORTED_MODULE_0_framebus__["off"](this._name, this._handler);
			return this;
		}
	}]);

	return Subscription;
}();

/***/ }),

/***/ "5wqq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newLogger;
/* unused harmony export setDefaultLevel */
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LEVEL_DEBUG = 0;
var LEVEL_INFO = 1;
var LEVEL_WARN = 2;
var LEVEL_ERROR = 3;

var LEVELS = ['debug', 'info', 'warn', 'error'];

var defaultLevel = window.IS_PRODUCTION ? LEVEL_WARN : LEVEL_DEBUG;

/**
 * Creates new logger instance with default level.
 * @param {string|null} name
 * @return {MyLogger}
 */
function newLogger() {
	var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

	return new MyLogger(name, defaultLevel);
}

/**
 * Sets level for new loggers.
 * @param {number} level
 */
function setDefaultLevel(level) {
	defaultLevel = level;
}

var MyLogger = function () {
	function MyLogger(name, level) {
		_classCallCheck(this, MyLogger);

		this._name = '';
		this._level = -1;

		this._dummy = function () {};

		this._name = name;
		this.setLevel(level);
	}

	_createClass(MyLogger, [{
		key: 'setLevel',
		value: function setLevel(level) {
			var _this = this;

			level = Number.isInteger(level) ? level : LEVELS.indexOf(level);
			this._level = level;

			var name = this._name ? '[' + this._name + ']' : null;
			var bind = function bind(condition, methodName) {
				if (!condition || !console[methodName]) return _this._dummy;
				return name ? console[methodName].bind(console, name) : console[methodName].bind(console);
			};
			var bindSimple = function bindSimple(condition, methodName) {
				return condition && console[methodName] ? console[methodName].bind(console) : _this._dummy;
			};

			[['log', LEVEL_DEBUG], ['info', LEVEL_INFO], ['warn', LEVEL_WARN], ['error', LEVEL_ERROR]].forEach(function (i) {
				var _i = _slicedToArray(i, 2),
				    method = _i[0],
				    lvl = _i[1];

				_this[method] = bind(level <= lvl, method);
			});

			['time', 'timeEnd', 'profile', 'profileEnd'].forEach(function (method) {
				_this[method] = bindSimple(level <= LEVEL_DEBUG, method);
			});
		}

		/** The same as {@link Console.log} */

	}, {
		key: 'log',
		value: function log(args) {}

		/** The same as {@link Console.info} */

	}, {
		key: 'info',
		value: function info(args) {}

		/** The same as {@link Console.warn} */

	}, {
		key: 'warn',
		value: function warn(args) {}

		/** The same as {@link Console.error} */

	}, {
		key: 'error',
		value: function error(args) {}

		/** The same as {@link Console.time} */

	}, {
		key: 'time',
		value: function time(label) {}

		/** The same as {@link Console.timeEnd} */

	}, {
		key: 'timeEnd',
		value: function timeEnd(label) {}

		/** The same as {@link Console.profile} */

	}, {
		key: 'profile',
		value: function profile(label) {}

		/** The same as {@link Console.profileEnd} */

	}, {
		key: 'profileEnd',
		value: function profileEnd(label) {}
	}, {
		key: 'measureTime',
		value: function measureTime(label, callable) {
			this.time(label);
			var result = callable();
			this.timeEnd(label);
			return result;
		}
	}, {
		key: 'doProfile',
		value: function doProfile(label, callable) {
			this.profile(label);
			var result = callable();
			this.profileEnd(label);
			return result;
		}
	}, {
		key: 'setLevelDebug',
		value: function setLevelDebug() {
			this.setLevel(LEVEL_DEBUG);
		}
	}, {
		key: 'setLevelInfo',
		value: function setLevelInfo() {
			this.setLevel(LEVEL_INFO);
		}
	}, {
		key: 'setLevelWarn',
		value: function setLevelWarn() {
			this.setLevel(LEVEL_WARN);
		}
	}, {
		key: 'setLevelError',
		value: function setLevelError() {
			this.setLevel(LEVEL_ERROR);
		}
	}]);

	return MyLogger;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (newLogger());

/***/ }),

/***/ "7fPx":
/***/ (function(module, exports) {

module.exports = ko;

/***/ }),

/***/ "DgU3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E27B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_autosize__ = __webpack_require__("xOlZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_knockout__ = __webpack_require__("7fPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lib_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__("0iPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_autosize___default.a);

window.autosize = __WEBPACK_IMPORTED_MODULE_0_autosize___default.a;

/**
 * Initializes Autosize plugin.
 * @param {string} method Allowed values: update, destroy
 * @return {JQuery}
 */
__WEBPACK_IMPORTED_MODULE_2_jquery___default.a.fn.autosize = function (method) {
	return this.each(function () {
		var el = this;
		var $el = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this);
		if (typeof method === 'string') {
			if ($el.data('autosize') && typeof __WEBPACK_IMPORTED_MODULE_0_autosize___default.a[method] === 'function') {
				console.log('calling autosize.' + method, 'on', el);
				__WEBPACK_IMPORTED_MODULE_0_autosize___default.a[method](el);
				$el.data('autosize', null);
			}
		} else {
			var o = _extends({
				/**
     * Defer plugin initialization until textarea gets focus
     */
				deferInit: false

			}, method);

			var init = function init() {
				__WEBPACK_IMPORTED_MODULE_0_autosize___default()(el);
				$el.data('autosize', true);
			};

			if (o.deferInit) {
				$el.one('focus', init);
			} else {
				init();
			}
		}
	});
};

/**
 * Binding for Autosize plugin
 */
__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.bindingHandlers.autosize = {
	init: function init(element, valueAccessor, allBindings, viewModel, bindingContext) {
		var $el = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(element);
		var options = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.unwrap(valueAccessor());
		var t = void 0;
		// autosize does not properly update itself when using with knockout
		// so manually fix it
		var update = function update() {
			if (t) {
				clearTimeout(t);
			}
			t = setTimeout(function () {
				$el.autosize('update');
			}, 100);
		};
		$el.autosize(options).on('change', update);

		__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.utils.domNodeDisposal.addDisposeCallback(element, function () {
			__WEBPACK_IMPORTED_MODULE_2_jquery___default()(element).autosize('destroy').off('change', update);
		});
	}
};

/***/ }),

/***/ "Elzt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FA3v":
/***/ (function(module, exports) {

module.exports = "<div class=\"user-info\">\n\t<a\n\t\thref=\"\"\n\t\tclass=\"user-photo\"\n\t\tdata-bind=\"attr: {href: author.url, 'aria-label': author.blogName}, style: author.avatar ? {backgroundImage: 'url(\\'' + author.avatar + '\\')'} : null\"\n\t></a>\n\t<div class=\"user-info-right\">\n\t\t<div class=\"user-info-header\">\n\t\t\t<a href=\"\" class=\"user-name\" data-bind=\"attr: {href: author.url}, text: author.blogName\"></a>\n\t\t\t<span class=\"user-level\" data-bind=\"css: 'user-level-' + author.level\"></span>\n\t\t</div>\n\t\t<!-- ko if: is_editable || (zde.currentUser !== null && zde.currentUser.roleId == 2) -->\n\t\t<span class=\"edit-comment\" data-bind=\"click: edit, clickBubble: false\" title=\"Редактировать\"></span>\n\t\t<span class=\"delete-comment\" data-bind=\"click: remove, clickBubble: false\" title=\"Удалить\"></span>\n\t\t<!-- /ko -->\n\t\t<!-- ko if: $parents[2].data().is_question && zde.currentUser !== null && zde.currentUser.roleId == 2 -->\n\t\t<span class=\"mark-comment-as-best\" data-bind=\"click: markAsBest, clickBubble: false\" title=\"Отметить ответ как лучший\"></span>\n\t\t<!-- /ko -->\n\t\t<span class=\"date\" data-bind=\"html: date_human\"></span>\n\t</div>\n</div>\n<div class=\"comment-text-wrapper collapsable\" data-bind=\"css: {collapsed: collapsed}\">\n\t<div class=\"comment-text collapsable\" data-bind=\"html: displayHtml\"></div>\n\t<span class=\"collapse-more\"\n\t  \tdata-bind=\"click: expand, clickBubble: false, visible: collapsed()\">... Читать далее</span>\n</div>\n<!-- ko if: !$parents[2].data().is_sale -->\n<div class=\"review-like\" data-bind=\"with: likers\">\n\t<div class=\"like-link\" data-bind=\"css: {'my-like': myLike}\">\n\t\t<a data-bind=\"event: {mouseover: show, mouseout: hide}, click: toggleMyLike\">\n\t\t\t<span class=\"like-title\" data-bind=\"text: zde.lang($parents[3].data().is_question ? 'txt_like_question_answer' : 'txt_like_review_comment')\"></span>\n\t\t\t<span class=\"count\" data-bind=\"text: likesCount\"></span>\n\t\t</a>\n\t\t<div class=\"review-tooltip likers\" data-bind=\"css: {visible: visible}\">\n\t\t\t<!-- ko if: likers -->\n\t\t\t<span class=\"likers-text\">\n\t\t\t\t\tПонравилось\n\t\t\t\t\t<span class=\"white\" data-bind=\"text: likesCountUsersText\"></span>\n\t\t\t\t</span>\n\t\t\t<div class=\"likers-links\" data-bind=\"foreach: likers, css: {'has-more': likers().length < likesCount()}\">\n\t\t\t\t<a href=\"\" data-bind=\"attr: {href: url}, text: name\"></a>\n\t\t\t</div>\n\t\t\t<!-- /ko -->\n\t\t\t<!-- ko else -->\n\t\t\t<span class=\"likers-text\">Нет лайков</span>\n\t\t\t<!-- /ko -->\n\t\t</div>\n\t</div>\n</div>\n<!-- /ko -->\n"

/***/ }),

/***/ "FCHk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_urlconverter__ = __webpack_require__("ejlv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_zinfinitescroll__ = __webpack_require__("wC9f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page__ = __webpack_require__("yVr+");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "page", function() { return __WEBPACK_IMPORTED_MODULE_2__page__; });






/***/ }),

/***/ "FYi7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BASE_URL; });
/* harmony export (immutable) */ __webpack_exports__["g"] = siteUrl;
/* harmony export (immutable) */ __webpack_exports__["f"] = joinPath;
/* harmony export (immutable) */ __webpack_exports__["e"] = isAbsolute;
/* unused harmony export buildQuery */
/* harmony export (immutable) */ __webpack_exports__["d"] = highlightUrls;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UrlParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UrlBuilder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__location__ = __webpack_require__("XRua");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__var__ = __webpack_require__("dTkA");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var BASE_URL = (window.base_url || '/').replace(/(.*)\/\/$|([^/])$/, '$1/');

var isAbsoluteUrlRegex = /^https?:\/\//i;

/**
 * @param {string|object} url Url path
 * @param {string|object} more Additional parts
 * @return {string}
 */
function siteUrl(url) {
	for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		more[_key - 1] = arguments[_key];
	}

	if (isAbsoluteUrlRegex.test(url)) {
		if (more.length === 0) {
			return url;
		} else {
			return joinPath.apply(null, [url].concat(more));
		}
	} else {
		return joinPath.apply(null, [BASE_URL, url].concat(more));
	}
}

/**
 * Joins given values with slash.
 * If last value is an object - it will be formatted as query data.
 * @param {string|object} values
 * @return {string}
 */
function joinPath() {
	for (var _len2 = arguments.length, values = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
		values[_key2] = arguments[_key2];
	}

	if (values.length == 0) return '';
	var query = {};
	var queryString = '';
	var fragment = '';
	var components = [];
	var processValue = function processValue(v) {
		if (__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isObject(v)) {
			query = _extends({}, query, v);
		} else {
			v = Object(__WEBPACK_IMPORTED_MODULE_2__var__["d" /* asString */])(v).trim();
			var i = void 0;
			if ((i = v.indexOf('#')) >= 0) {
				fragment = v.substr(i + 1);
				v = v.substr(0, i);
			} else if ((i = v.indexOf('?')) >= 0) {
				queryString = v.substr(i + 1);
				v = v.substr(0, i);
			}
			if (v) {
				if (components.length == 0) {
					v = v.replace(/\/$/g, '');
				} else {
					v = v.replace(/^\/|\/$/g, '');
				}
				components.push(v);
			}
		}
	};
	values.forEach(function (v) {
		if (__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isArray(v)) {
			v.forEach(processValue);
		} else {
			processValue(v);
		}
	});
	var url = components.join('/');
	if (!__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isEmpty(query)) {
		var q = buildQuery(query);
		if (queryString) {
			queryString += '&';
		}
		queryString += q;
	}
	if (queryString) {
		url += '?' + queryString;
	}
	if (fragment) {
		url += '#' + fragment;
	}
	return url;
}

/**
 *
 * @param {string} url
 * @return {boolean}
 */
function isAbsolute(url) {
	return isAbsoluteUrlRegex.test(url);
}

/**
 * Builds query string from given object
 * @param {object} queryData
 * @return {string}
 */
function buildQuery(queryData) {
	return __WEBPACK_IMPORTED_MODULE_1__location__["c" /* buildQuery */](queryData);
}

function highlightUrls(text) {
	var maxlength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;

	return text.replace(/(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\?+=&%#\/\wА-Яа-яёЁ\.;-]*)*\/?/g, function (s) {
		var st = s;

		if (s.length > maxlength) {
			st = s.slice(0, maxlength) + "...";
		}

		if (!/^(https?:\/\/)/.test(s)) {
			s = "http://" + s;
		}

		return "<a href='" + s + "' target='_blank' rel='nofollow noopener'>" + st + "</a>";
	});
}

var UrlParser = function () {
	/**
  * @param {string} url
  */
	function UrlParser(url) {
		_classCallCheck(this, UrlParser);

		this._a = document.createElement('a');
		this._a.href = url;
	}

	/** @return {string} */


	_createClass(UrlParser, [{
		key: 'origin',
		get: function get() {
			return this._a.origin;
		}

		/** @return {string} */

	}, {
		key: 'protocol',
		get: function get() {
			return this._a.protocol;
		}

		/** @return {string} */

	}, {
		key: 'host',
		get: function get() {
			return this._a.host;
		}

		/** @return {string} */

	}, {
		key: 'hostname',
		get: function get() {
			return this._a.hostname;
		}

		/** @return {string} */

	}, {
		key: 'port',
		get: function get() {
			return this._a.port;
		}

		/** @return {string} */

	}, {
		key: 'pathname',
		get: function get() {
			return this._a.pathname;
		}

		/** @return {string} */

	}, {
		key: 'search',
		get: function get() {
			return this._a.search;
		}

		/** @return {string} */

	}, {
		key: 'hash',
		get: function get() {
			return this._a.hash;
		}
	}]);

	return UrlParser;
}();

var UrlBuilder = function () {
	function UrlBuilder() {
		var protocol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
		var host = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
		var port = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
		var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
		var query = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
		var hash = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

		_classCallCheck(this, UrlBuilder);

		this._protocol = protocol;
		this._host = host;
		this._port = port;
		this._path = path;
		this._query = query;
		this._hash = hash;
	}

	/**
  * @param {string|null} value
  */


	_createClass(UrlBuilder, [{
		key: 'build',


		/**
   * @return {string}
   */
		value: function build() {
			var origin = (this._protocol ? this._protocol + '//' : '') + (this._host ? this._host + (this._port ? ':' + this._port : '') : '');
			var query = _typeof(this._query) === 'object' ? prefix(buildQuery(this._query), '?') : this._query;
			return joinPath(origin, this._path, query, this._hash);
		}
	}, {
		key: 'protocol',
		set: function set(value) {
			this._protocol = postfix(value, ':');
		}

		/** @return {string|null} */
		,
		get: function get() {
			return this._protocol;
		}

		/**
   * @param {string|null} value
   */

	}, {
		key: 'host',
		set: function set(value) {
			this._host = value;
		}

		/** @return {string|null} */
		,
		get: function get() {
			return this._host;
		}

		/**
   * @param {string|number|null} value
   */

	}, {
		key: 'port',
		set: function set(value) {
			this._port = value;
		}

		/** @return {string|number|null} */
		,
		get: function get() {
			return this._port;
		}

		/**
   * @param {string|null} value
   */

	}, {
		key: 'path',
		set: function set(value) {
			this._path = value;
		}

		/** @return {string|null} */
		,
		get: function get() {
			return this._path;
		}

		/**
   * @param {string|object|null} value
   */

	}, {
		key: 'query',
		set: function set(value) {
			this._query = prefix(value, '?');
		}

		/** @return {string|object|null} */
		,
		get: function get() {
			return this._query;
		}

		/**
   * @param {string|null} value
   */

	}, {
		key: 'hash',
		set: function set(value) {
			this._hash = prefix(value, '#');
		}

		/** @return {string|null} */
		,
		get: function get() {
			return this._hash;
		}
	}]);

	return UrlBuilder;
}();

function prefix(val, prefix) {
	if (val && typeof val === 'string' && !val.startsWith(prefix)) {
		return prefix + val;
	}
	return val;
}

function postfix(val, postfix) {
	if (val && typeof val === 'string' && !val.endsWith(postfix)) {
		return val + postfix;
	}
	return val;
}

/***/ }),

/***/ "FZjg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReviewItemMobile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reviewitem__ = __webpack_require__("/ryK");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var ReviewItemMobile = function (_ReviewItem) {
    _inherits(ReviewItemMobile, _ReviewItem);

    function ReviewItemMobile(data) {
        _classCallCheck(this, ReviewItemMobile);

        data.columns = false;
        data.infScrollDistance = 300;

        var _this = _possibleConstructorReturn(this, (ReviewItemMobile.__proto__ || Object.getPrototypeOf(ReviewItemMobile)).call(this, data));

        _this.opened = ko.observable(false);


        _this.afterCommentRender = _this._afterCommentRender.bind(_this);
        _this.newComment.isSaveButtonVisible.subscribe(_this._onCommentAddButtonToggle.bind(_this));
        return _this;
    }

    _createClass(ReviewItemMobile, [{
        key: '_afterCommentRender',
        value: function _afterCommentRender() {
            if (this.opened()) {
                var $panel = $('#review-list-item-mobile-' + this.id).find('.dropdown-content');
                this._setCommentsPanelSize($panel);
            }
        }
    }, {
        key: '_onCommentAddButtonToggle',
        value: function _onCommentAddButtonToggle(value) {
            var $panel = $('#review-list-item-mobile-' + this.id).find('.dropdown-content');
            var height = $panel.find('.content-inner').innerHeight();
            var buttonHeight = $panel.find('.add-comment-button').outerHeight();
            $panel.css('height', value ? height + buttonHeight : height - buttonHeight);
        }
    }, {
        key: '_setCommentsPanelSize',
        value: function _setCommentsPanelSize($content) {
            var height = $content.find('.content-inner').innerHeight();
            $content.css('height', height);
        }
    }, {
        key: 'toggleDetails',
        value: function toggleDetails(item, event) {
            var $toggler = $(event.currentTarget);
            var $content = $toggler.siblings('.dropdown-content');

            if (this.opened()) {
                $content.css('height', 0);
            } else {
                this._setCommentsPanelSize($content);
            }

            this.opened(!this.opened());
        }
    }]);

    return ReviewItemMobile;
}(__WEBPACK_IMPORTED_MODULE_0__reviewitem__["a" /* ReviewItem */]);

/***/ }),

/***/ "GTd5":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "HNTF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TYPE_REVIEW_LIKE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TYPE_COMMENT_LIKE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TYPE_SALE_LIKE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Likers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("0iPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_auth__ = __webpack_require__("UpRQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_widgets_notifier__ = __webpack_require__("2uje");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_utils_url__ = __webpack_require__("FYi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_utils_lang__ = __webpack_require__("RaK1");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var TYPE_REVIEW_LIKE = 'review_like';
var TYPE_COMMENT_LIKE = 'comment_like';
var TYPE_SALE_LIKE = 'sale_like';

var Likers = function () {
	function Likers(reviewId, likesCount, myLike) {
		var _this = this;

		var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : TYPE_REVIEW_LIKE;

		_classCallCheck(this, Likers);

		this.visible = ko.observable(false);
		this.loading = ko.observable(false);
		this.likers = ko.observableArray([]);
		this.likesCount = ko.observable(0);
		this.myLike = ko.observable(false);
		this.type = null;

		this.reviewId = reviewId;
		this.likesCount(+likesCount);
		this.myLike(!!myLike);

		this.likesCountUsersText = ko.pureComputed(function () {
			return __WEBPACK_IMPORTED_MODULE_4__core_utils_lang__["b" /* pluralize */](_this.likesCount(), '{n} пользователю|{n} пользователям|{n} пользователям', 'n');
		});

		switch (type) {
			case TYPE_REVIEW_LIKE:
				this._saveUrl = '/reviews/save_like';
				this._getLikersUrl = '/reviews/get_likers_ajax';
				break;
			case TYPE_COMMENT_LIKE:
				this._saveUrl = '/reviews/save_comment_like';
				this._getLikersUrl = '/reviews/get_comment_likers_ajax';
				break;
			case TYPE_SALE_LIKE:
				this._saveUrl = '/blog/likes_save';
				this._getLikersUrl = '/blog/get_likers';
				break;
		}
	}

	_createClass(Likers, [{
		key: "show",
		value: function show() {
			var _this2 = this;

			this._load().done(function () {
				_this2.visible(_this2.likesCount() > 0);
			});
		}
	}, {
		key: "hide",
		value: function hide() {
			this.visible(false);
		}
	}, {
		key: "toggleMyLike",
		value: function toggleMyLike(data, e) {
			var _this3 = this;

			e.stopPropagation();
			Object(__WEBPACK_IMPORTED_MODULE_1_core_auth__["ensureLoggedIn"])(function () {
				__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_3_core_utils_url__["g" /* siteUrl */])(_this3._saveUrl), { id: _this3.reviewId }, null, 'json').fail(__WEBPACK_IMPORTED_MODULE_2_core_widgets_notifier__["a" /* Notifier */].errorXHR).done(function (response) {
					if (response && response.success) {
						_this3.likesCount(+response.likes);
						_this3.myLike(response.myAction && response.myAction == 'up' || response.action && response.action == 'up');
					} else {
						__WEBPACK_IMPORTED_MODULE_2_core_widgets_notifier__["a" /* Notifier */].error();
					}
				});
			});
		}
	}, {
		key: "_load",
		value: function _load() {
			var _this4 = this;

			this.loading(true);
			return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_3_core_utils_url__["g" /* siteUrl */])(this._getLikersUrl), { id: this.reviewId }, null, 'json').done(function (response) {
				_this4.likesCount(+response.total);
				_this4.likers(response.likers);
				_this4.loading(false);
			});
		}
	}]);

	return Likers;
}();

/***/ }),

/***/ "Oe2b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
(function (root, factory) {
  if (true) {
    module.exports = factory(typeof global === 'undefined' ? root : global);
  } else if (typeof define === 'function' && define.amd) {
    define([], function () { return factory(root); });
  } else {
    root.framebus = factory(root);
  }
})(this, function (root) { // eslint-disable-line no-invalid-this
  var win, framebus;
  var popups = [];
  var subscribers = {};
  var prefix = '/*framebus*/';

  function include(popup) {
    if (popup == null) { return false; }
    if (popup.Window == null) { return false; }
    if (popup.constructor !== popup.Window) { return false; }

    popups.push(popup);
    return true;
  }

  function target(origin) {
    var key;
    var targetedFramebus = {};

    for (key in framebus) {
      if (!framebus.hasOwnProperty(key)) { continue; }

      targetedFramebus[key] = framebus[key];
    }

    targetedFramebus._origin = origin || '*';

    return targetedFramebus;
  }

  function publish(event) {
    var payload, args;
    var origin = _getOrigin(this); // eslint-disable-line no-invalid-this

    if (_isntString(event)) { return false; }
    if (_isntString(origin)) { return false; }

    args = Array.prototype.slice.call(arguments, 1);

    payload = _packagePayload(event, args, origin);
    if (payload === false) { return false; }

    _broadcast(win.top || win.self, payload, origin);

    return true;
  }

  function subscribe(event, fn) {
    var origin = _getOrigin(this); // eslint-disable-line no-invalid-this

    if (_subscriptionArgsInvalid(event, fn, origin)) { return false; }

    subscribers[origin] = subscribers[origin] || {};
    subscribers[origin][event] = subscribers[origin][event] || [];
    subscribers[origin][event].push(fn);

    return true;
  }

  function unsubscribe(event, fn) {
    var i, subscriberList;
    var origin = _getOrigin(this); // eslint-disable-line no-invalid-this

    if (_subscriptionArgsInvalid(event, fn, origin)) { return false; }

    subscriberList = subscribers[origin] && subscribers[origin][event];
    if (!subscriberList) { return false; }

    for (i = 0; i < subscriberList.length; i++) {
      if (subscriberList[i] === fn) {
        subscriberList.splice(i, 1);
        return true;
      }
    }

    return false;
  }

  function _getOrigin(scope) {
    return scope && scope._origin || '*';
  }

  function _isntString(string) {
    return typeof string !== 'string';
  }

  function _packagePayload(event, args, origin) {
    var packaged = false;
    var payload = {
      event: event,
      origin: origin
    };
    var reply = args[args.length - 1];

    if (typeof reply === 'function') {
      payload.reply = _subscribeReplier(reply, origin);
      args = args.slice(0, -1);
    }

    payload.args = args;

    try {
      packaged = prefix + JSON.stringify(payload);
    } catch (e) {
      throw new Error('Could not stringify event: ' + e.message);
    }
    return packaged;
  }

  function _unpackPayload(e) {
    var payload, replyOrigin, replySource, replyEvent;

    if (e.data.slice(0, prefix.length) !== prefix) { return false; }

    try {
      payload = JSON.parse(e.data.slice(prefix.length));
    } catch (err) {
      return false;
    }

    if (payload.reply != null) {
      replyOrigin = e.origin;
      replySource = e.source;
      replyEvent = payload.reply;

      payload.reply = function reply(data) { // eslint-disable-line consistent-return
        var replyPayload = _packagePayload(replyEvent, [data], replyOrigin);

        if (replyPayload === false) { return false; }

        replySource.postMessage(replyPayload, replyOrigin);
      };

      payload.args.push(payload.reply);
    }

    return payload;
  }

  function _attach(w) {
    if (win) { return; }
    win = w || root;

    if (win.addEventListener) {
      win.addEventListener('message', _onmessage, false);
    } else if (win.attachEvent) {
      win.attachEvent('onmessage', _onmessage);
    } else if (win.onmessage === null) {
      win.onmessage = _onmessage;
    } else {
      win = null;
    }
  }

  function _uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      var v = c === 'x' ? r : r & 0x3 | 0x8;

      return v.toString(16);
    });
  }

  function _onmessage(e) {
    var payload;

    if (_isntString(e.data)) { return; }

    payload = _unpackPayload(e);
    if (!payload) { return; }

    _dispatch('*', payload.event, payload.args, e);
    _dispatch(e.origin, payload.event, payload.args, e);
    _broadcastPopups(e.data, payload.origin, e.source);
  }

  function _dispatch(origin, event, args, e) {
    var i;

    if (!subscribers[origin]) { return; }
    if (!subscribers[origin][event]) { return; }

    for (i = 0; i < subscribers[origin][event].length; i++) {
      subscribers[origin][event][i].apply(e, args);
    }
  }

  function _hasOpener(frame) {
    if (frame.top !== frame) { return false; }
    if (frame.opener == null) { return false; }
    if (frame.opener === frame) { return false; }
    if (frame.opener.closed === true) { return false; }

    return true;
  }

  function _broadcast(frame, payload, origin) {
    var i;

    try {
      frame.postMessage(payload, origin);

      if (_hasOpener(frame)) {
        _broadcast(frame.opener.top, payload, origin);
      }

      for (i = 0; i < frame.frames.length; i++) {
        _broadcast(frame.frames[i], payload, origin);
      }
    } catch (_) { /* ignored */ }
  }

  function _broadcastPopups(payload, origin, source) {
    var i, popup;

    for (i = popups.length - 1; i >= 0; i--) {
      popup = popups[i];

      if (popup.closed === true) {
        popups = popups.slice(i, 1);
      } else if (source !== popup) {
        _broadcast(popup.top, payload, origin);
      }
    }
  }

  function _subscribeReplier(fn, origin) {
    var uuid = _uuid();

    function replier(d, o) {
      fn(d, o);
      framebus.target(origin).unsubscribe(uuid, replier);
    }

    framebus.target(origin).subscribe(uuid, replier);
    return uuid;
  }

  function _subscriptionArgsInvalid(event, fn, origin) {
    if (_isntString(event)) { return true; }
    if (typeof fn !== 'function') { return true; }
    if (_isntString(origin)) { return true; }

    return false;
  }

  _attach();

  framebus = {
    target: target,
    include: include,
    publish: publish,
    pub: publish,
    trigger: publish,
    emit: publish,
    subscribe: subscribe,
    sub: subscribe,
    on: subscribe,
    unsubscribe: unsubscribe,
    unsub: unsubscribe,
    off: unsubscribe
  };

  return framebus;
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("GTd5")))

/***/ }),

/***/ "QQLA":
/***/ (function(module, exports) {

module.exports = "<div class=\"review-header\">\n\t<!-- ko if: data().is_editable || (!data().is_sale && zde.currentUser !== null && zde.currentUser.roleId == 2) -->\n\t<div class=\"review-edit-wrap\">\n\t\t<span class=\"edit-review\" title=\"Редактировать\" data-bind=\"click: edit\" ></span>\n\t\t<span class=\"delete-review\" title=\"Удалить\" data-bind=\"click: remove\"></span>\n\t\t<!-- ko if: zde.currentUser.roleId == 2 -->\n\t\t<a class=\"edit-review-for-whom\" data-bind=\"text: forWhomTitle, click: changeForWhom\"></a>\n\t\t<div class=\"close-review-wrapper\">\n\t\t\t<label data-bind=\"attr: {for: 'is_closed_review_state_' + id}\">Закрыт</label>\n\t\t\t<input type=\"checkbox\" data-bind=\"checked: isClosed, attr: {id: 'is_closed_review_state_' + id}\" />\n\t\t</div>\n\t\t<!-- /ko -->\n\t</div>\n\t<!-- /ko -->\n\t<!-- ko if: showImage -->\n\t\t<!-- ko if: data().is_question -->\n\t\t<a href=\"\" data-bind=\"attr: {href: data().url}\">\n\t\t\t<img\n\t\t\t\tclass=\"review-photo\"\n\t\t\t\tsrc=\"\"\n\t\t\t\tdata-bind=\"attr: {\n\t\t\t\t\tsrc: data().preview,\n\t\t\t\t\talt: data().title,\n\t\t\t\t\twidth: data().preview_width,\n\t\t\t\t\theight: data().preview_height\n\t\t\t\t}\"\n\t\t\t/>\n\t\t</a>\n\t\t<!-- /ko -->\n\t\t<!-- ko else -->\n\t\t<a href=\"\" data-bind=\"attr: {href: data().url}, click: handleClick\">\n\t\t\t<img\n\t\t\t    class=\"review-photo\"\n\t\t\t\tsrc=\"\"\n\t\t\t\tdata-bind=\"\n\t\t\t\t\tattr: {\n\t\t\t\t\t\tsrc: data().preview,\n\t\t\t\t\t\talt: data().preview_title,\n\t\t\t\t\t\twidth: data().preview_width,\n\t\t\t\t\t\theight: data().preview_height\n\t\t\t\t\t},\n\t\t\t\t\tcss: {'sale-thumbnail-1': data().is_sale }\n\t\t\t\t\"\n\t\t\t>\n\t\t</a>\n\t\t<!-- /ko -->\n\t\t<!-- ko if: data().is_sale && data().preview_2 -->\n\t\t<a href=\"\" data-bind=\"attr: {href: data().url}\">\n\t\t\t<img class=\"sale-thumbnail-2\" src=\"\" data-bind=\"attr: {src: data().preview_2, alt: data().preview_title}\">\n\t\t</a>\n\t\t<!-- /ko -->\n\t<!-- /ko -->\n\t<!-- ko if: showVideo && data().is_video -->\n\t<div class=\"video-wrapper\">\n\t\t<iframe\n\t\t\tdata-bind=\"attr: { src: getVideoUrl(isDetailsPage) }\"\n\t\t\tframeborder=\"0\"\n\t\t\tallowfullscreen\n\t\t\tallow=\"autoplay\"\n\t\t\tclass=\"video-content\"\n\t\t>\n\t\t</iframe>\n\t</div>\n\t<!-- /ko -->\n\t<!-- ko if: isAuthorHidden -->\n\t<div class=\"user-info\">\n\t\t<div class=\"user-info-right\">\n\t\t\t<span class=\"date\" data-bind=\"html: data().date_human\"></span>\n\t\t</div>\n\t</div>\n\t<!-- /ko -->\n\t<!-- ko else -->\n\t<div class=\"user-info\" data-bind=\"with: author\">\n\t\t<a href=\"\" class=\"user-photo\" data-bind=\"attr: {href: url, 'aria-label': blogName}, style: {backgroundImage: 'url(\\'' + avatar + '\\')'}\"></a>\n\t\t<div class=\"user-info-right\">\n\t\t\t<div class=\"user-info-header\">\n\t\t\t\t<a href=\"\" class=\"user-name\" data-bind=\"attr: {href: url}, text: blogName\"></a>\n\t\t\t\t<span class=\"dashes\"></span>\n\t\t\t\t<span class=\"user-level\" data-bind=\"css: 'user-level-' + level\"></span>\n\t\t\t</div>\n\t\t\t<span class=\"date\" data-bind=\"html: $parent.data().date_human\"></span>\n\t\t</div>\n\t</div>\n\t<!-- /ko -->\n</div>\n\n<!-- ko if: data().is_question -->\n<div class=\"question-info-block\">\n\t<a href=\"\" class=\"question-title\"\n\t   data-bind=\"attr: {href: titleUrl, title: showImage ? data().title : false}, html: data().title\"></a>\n</div>\n<!-- /ko -->\n<!-- ko else -->\n\t<!-- ko if: !data().is_sale -->\n\t<div class=\"product-block\">\n\t\t<div>\n\t\t\t<a href=\"\" class=\"product-name\" rel=\"nofollow noopener\" target=\"_blank\"\n\t\t\t   data-bind=\"attr: {href: titleUrl, title: data().title}, html: data().title\"></a>\n\t\t</div>\n\n\t\t<div data-bind=\"with: data().our_info\">\n\t\t\t<a href=\"\" class=\"product-name\" rel=\"nofollow noopener\" target=\"_blank\"\n\t\t\t   data-bind=\"attr: {href: link, title: product_name}, text: product_name\"></a>\n\t\t</div>\n\n\t\t<div data-bind=\"with: data().old_info\">\n\t\t\t<span data-bind=\"text: type == 'question' ? 'вопроса': 'отзыва' \"></span>:\n\t\t\t<a href=\"\" class=\"product-name\" rel=\"nofollow noopener\" target=\"_blank\"\n\t\t\t   data-bind=\"attr: {href: url}, text: host\"></a>\n\t\t</div>\n\n\t\t<div class=\"product-info\" data-bind=\"with: data\">\n\t\t\t<span class=\"price\">\n\t\t\t\t<!-- ko if: price -->\n\t\t\t\tЗа <span class=\"bold\" data-bind=\"text: price + ' &euro;'\"></span>\n\t\t\t\t<!-- /ko -->\n\t\t\t\t<!-- ko if: shop_name -->\n\t\t\t\tиз <a href=\"\" class=\"shop\" data-bind=\"attr: {href: shop_url}, text: shop_name\"></a>\n\t\t\t\t<!-- /ko -->\n\t\t\t</span>\n\t\t\t<div class=\"rate-stars\" data-bind=\"visible: rating, css: 'rate-stars-' + rating\"></div>\n\t\t</div>\n\t</div>\n\t<!-- /ko -->\n<!-- /ko -->\n\n<div class=\"on-sale-wrapper\" data-bind=\"visible: data().forsale\">\n\t<div class=\"on-sale\">\n\t\tOn sale\n\t\t<span class=\"review-tooltip\">\n\t\t\tТовар был приобретен через наш сайт и выставлен покупателем на продажу.\n\t\t\tДанный функционал не предусматривает коммерческой выгоды,\n\t\t\tа лишь дает возможность перепродать не подошедший товар (например по размеру) по закупочной цене.\n\t\t</span>\n\t</div>\n\t<span class=\"on-sale-message\">Товар выставлен на продажу</span>\n</div>\n\n<div class=\"review-main\">\n\t<!-- ko if: !isBodyLess() -->\n\t\t<!-- ko if: !data().is_sale -->\n\t\t<a href=\"\" class=\"review-text-wrapper collapsable\"\n\t\t   data-bind=\"attr: {href: data().url}, click: handleClick, css: {collapsed: collapsed}\">\n\t\t\t<div class=\"review-text\" data-bind=\"html: displayHtml\"></div>\n\t\t\t<span class=\"collapse-more\"\n\t\t\t\t  data-bind=\"click: expand, clickBubble: false, visible: collapsed()\">... Читать далее</span>\n\t\t</a>\n\t\t<!-- /ko -->\n\t\t<!-- ko if: data().is_sale && data().text -->\n\t\t<div class=\"review-text\" data-bind=\"html: displayHtml\"></div>\n\t\t<!-- /ko -->\n\t<!-- /ko -->\n\t<div class=\"review-like\" data-bind=\"with: likers\">\n\t\t<div class=\"like-link\" data-bind=\"css: {'my-like': myLike}\">\n\t\t\t<a data-bind=\"event: {mouseover: show, mouseout: hide}, click: toggleMyLike\">\n\t\t\t\t<span\n\t\t\t\t    class=\"like-title\"\n\t\t\t\t\tdata-bind=\"text: zde.lang($parent.data().is_question ? 'txt_like_question' : ($parent.data().is_sale ? 'txt_like_sale' : 'txt_like_review'))\"\n\t\t\t\t></span>\n\t\t\t\t<span class=\"count\" data-bind=\"text: likesCount\"></span>\n\t\t\t</a>\n\t\t\t<div class=\"review-tooltip likers\" data-bind=\"css: {visible: visible}\">\n\t\t\t\t<!-- ko if: likers -->\n\t\t\t\t<span class=\"likers-text\">\n\t\t\t\t\tПонравилось\n\t\t\t\t\t<span class=\"white\" data-bind=\"text: likesCountUsersText\"></span>\n\t\t\t\t</span>\n\t\t\t\t<div class=\"likers-links\" data-bind=\"foreach: likers, css: {'has-more': likers().length < likesCount()}\">\n\t\t\t\t\t<a href=\"\" data-bind=\"attr: {href: url}, text: name\"></a>\n\t\t\t\t</div>\n\t\t\t\t<!-- /ko -->\n\t\t\t\t<!-- ko else -->\n\t\t\t\t<span class=\"likers-text\">Нет лайков</span>\n\t\t\t\t<!-- /ko -->\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n<div class=\"comments-block\" data-bind=\"with: data, click: handleClick\">\n\t<div class=\"links-wrapper\">\n\t\t<a class=\"comments-block-link direct-link reviews\" href=\"\" data-bind=\"visible: similar_reviews_count > 0,\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t  attr: {href: similar_reviews_url},\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t  click: $parent.handleClick, clickBubble: false\">\n\t\t\t<span>Ещё <span data-bind=\"text: similar_reviews_count_text\"></span> на этот товар</span>\n\t\t</a>\n\t\t<a class=\"comments-block-link comments\" href=\"\" data-bind=\"visible: more_comments_count > 0,\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   attr: {href: url, target: $parent.data().is_question ? '_blank' : '_self'},\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   css: {'direct-link': $parent.data().is_question,\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   click: $parent.handleClick, clickBubble: false}\">\n\t\t\t<span>Ещё <span data-bind=\"text: more_comments_count_text\"></span></span>\n\t\t</a>\n\t</div>\n\t<div data-bind=\"foreach: $parent.comments\">\n\t\t<div class=\"comment-item\" data-bind=\"component: {name: 'review-comment', params: $data}, css: {best: $data.best}\"></div>\n\t</div>\n\t<!-- ko else -->\n\t<div class=\"no-comments\">\n\t\t<!-- ko if: is_question -->\n\t\tНет ответов\n\t\t<!-- /ko -->\n\t\t<!-- ko else: -->\n\t\tНет комментариев\n\t\t<!-- /ko -->\n\t</div>\n\t<!-- /ko -->\n</div>\n\n<div class=\"add-comment-block\" data-bind=\"with: newComment\">\n\t<!-- ko if: !$parent.isClosed() -->\n\t<form method=\"post\" data-bind=\"submit: save\">\n\t\t<textarea rows=\"1\" placeholder=\"Введите свой комментарий\"\n\t\t\t\t  data-bind=\"textInput: text, autosize: {deferInit: true}, hasFocus: inputHasFocus\"></textarea>\n\t\t<button data-bind=\"visible: isSaveButtonVisible\">Отправить</button>\n\t</form>\n\t<!-- /ko -->\n</div>\n\n<!-- Following string is a workaround to bind afterRender to component -->\n<span style=\"display: none\" data-bind=\"template: {afterRender: afterRender, nodes: $('<span></span>')}\"></span>"

/***/ }),

/***/ "R7O4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReviewComment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__likers__ = __webpack_require__("HNTF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_auth__ = __webpack_require__("UpRQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_modals__ = __webpack_require__("YdFU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_utils_url__ = __webpack_require__("FYi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_widgets_notifier__ = __webpack_require__("2uje");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








var ReviewComment = function () {
	function ReviewComment(data) {
		var _this = this;

		_classCallCheck(this, ReviewComment);

		this._parent = null;

		this._data = data;
		this._parent = data.parent;
		this._author = data.author instanceof __WEBPACK_IMPORTED_MODULE_1__core_auth__["UserInfo"] ? data.author : new __WEBPACK_IMPORTED_MODULE_1__core_auth__["UserInfo"](data.author);

		this._data.best = ko.observable(this._data.best);
		this._data.text = ko.observable(this._data.text);
		this._data.date_human = ko.observable(this._data.date_human);
		this._likers = new __WEBPACK_IMPORTED_MODULE_0__likers__["a" /* Likers */](this.id, data.likes, data.my_like, __WEBPACK_IMPORTED_MODULE_0__likers__["b" /* TYPE_COMMENT_LIKE */]);

		this.collapsed = ko.observable(true);
		this.displayHtml = ko.pureComputed(function () {
			return Object(__WEBPACK_IMPORTED_MODULE_3_core_utils_url__["d" /* highlightUrls */])(_this._data.text());
		});
	}

	/** @return {int} */

	/** @var {ReviewItem} */


	_createClass(ReviewComment, [{
		key: "expand",
		value: function expand() {
			this.collapsed(false);
		}
	}, {
		key: "remove",
		value: function remove() {
			if (confirm('Вы действительно хотите удалить комментарий?')) {
				this._parent.deleteComment(this);
			}
		}
	}, {
		key: "edit",
		value: function edit() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_2__core_modals__["MODAL_REVIEW_COMMENT_EDIT"].show(this.id, function (response) {
				if (response && response.success) {
					_this2._data.text(response.text);
					if (response.date) {
						_this2._data.date = response.date;
						_this2._data.date_human(response.date_human);
					}
				}
			});
		}
	}, {
		key: "markAsBest",
		value: function markAsBest() {
			var _this3 = this;

			$.post(Object(__WEBPACK_IMPORTED_MODULE_3_core_utils_url__["g" /* siteUrl */])('reviews/mark_comment_as_best'), { id: this.id }, null, 'json').done(function (response) {
				if (response.success) {
					_this3._parent.comments.forEach(function (comment) {
						return comment.best(false);
					});
					_this3.best(true);
					__WEBPACK_IMPORTED_MODULE_4_core_widgets_notifier__["a" /* Notifier */].success('Ответ отмечен как лучший');
				} else {
					__WEBPACK_IMPORTED_MODULE_4_core_widgets_notifier__["a" /* Notifier */].error();
				}
			}).fail(__WEBPACK_IMPORTED_MODULE_4_core_widgets_notifier__["a" /* Notifier */].errorXHR);
		}
	}, {
		key: "id",
		get: function get() {
			return this._data.id;
		}

		/** @return {UserInfo} */

	}, {
		key: "author",
		get: function get() {
			return this._author;
		}

		/** @return {string} Date in format Y-m-d H:i:s */

	}, {
		key: "date",
		get: function get() {
			return this._data.date;
		}

		/** @return {bool} Relative date */

	}, {
		key: "best",
		get: function get() {
			return this._data.best;
		}

		/** @return {string} Relative date */

	}, {
		key: "date_human",
		get: function get() {
			return this._data.date_human;
		}

		/** @return {bool} */

	}, {
		key: "is_editable",
		get: function get() {
			return this._data.is_editable;
		}

		/** @return {Likers} */

	}, {
		key: "likers",
		get: function get() {
			return this._likers;
		}
	}]);

	return ReviewComment;
}();

/***/ }),

/***/ "RaK1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lang;
/* unused harmony export tmpl */
/* harmony export (immutable) */ __webpack_exports__["b"] = pluralize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_knockout__ = __webpack_require__("7fPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_smart_plurals__ = __webpack_require__("tXil");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_smart_plurals___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_smart_plurals__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globals__ = __webpack_require__("TxBK");




/**
 * Renders phrase
 * @param {string} lang Phrase name
 * @param {object|null} [data]
 * @param {boolean} [asHtml] Whether to render variables decorated with span tag. Default is FALSE
 * @returns {string} Rendered phrase
 */
function lang(lang) {
	var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	var asHtml = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	var phrase = Object(__WEBPACK_IMPORTED_MODULE_2__globals__["b" /* phrases */])()[lang];
	if (!phrase) return lang;
	return tmpl(phrase, data, asHtml);
}

/**
 *
 * @param {string} template
 * @param {object|null} [data]
 * @param {boolean} [asHtml] Whether to render variables decorated with span tag. Default is TRUE
 * @returns {string}
 */
function tmpl(template) {
	var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	var asHtml = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	if (!data) return template;
	template = '' + template;

	var result = template;
	for (var key in data) {
		if (!data.hasOwnProperty(key)) continue;
		var val = data[key];

		// unwrap value
		if (typeof val === 'function') {
			val = val();
		}

		var keyParam = escapeRegExp(key);
		var pluralRegex = new RegExp("\\[([^\\]]+{" + keyParam + "}[^\\]]+)\\]");
		var m = pluralRegex.exec(template);
		if (m) {
			result = result.replace(pluralRegex, pluralize(val, m[1], key));
		}

		var replacement = asHtml ? '<span class="tmpl-var-' + key + '">' + val + '</span>' : val;
		result = result.split('{' + key + '}').join(replacement);
	}
	return result;
}

/**
 *
 * @param {number} count
 * @param {string} text
 * @param {string} varName
 * @param {string|number|null} varValue
 */
function pluralize(count, text) {
	var varName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'n';
	var varValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

	var parts = text.split('|');
	var pluralRule = __WEBPACK_IMPORTED_MODULE_1_smart_plurals___default.a.Plurals.getRule(LANG);
	var part = pluralRule(count, parts);
	if (part === undefined) {
		part = parts[0];
	}
	var replacement = varValue !== undefined && varValue !== null ? varValue : count;
	return part.split('{' + varName + '}').join(replacement);
}

function escapeRegExp(string) {
	return string.replace(/([.*+?^${}()|\[\]\/\\])/g, "\\$1");
}

__WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.bindingHandlers['lang'] = {
	init: function init() {
		return { 'controlsDescendantBindings': true };
	},
	update: function update(element, valueAccessor) {
		var params = __WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.unwrap(valueAccessor());
		var o = {
			name: '',
			data: undefined,
			html: undefined
		};
		if (!$.isPlainObject(params)) {
			o.name = params;
		} else {
			$.extend(o, params);
		}
		var args = [o.name, o.data, o.html];
		var val = lang.apply(this, args);
		__WEBPACK_IMPORTED_MODULE_0_lib_knockout___default.a.utils.setHtml(element, val);
	}
};

/***/ }),

/***/ "S/qL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_index_less__ = __webpack_require__("Elzt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blocks_last_comments_lastcomments__ = __webpack_require__("mvuq");



function init() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    __WEBPACK_IMPORTED_MODULE_1__blocks_last_comments_lastcomments__["a" /* init */]({
        commentsType: 'reviews',
        reviewType: type
    });
}

/***/ }),

/***/ "TxBK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = globals;
/* harmony export (immutable) */ __webpack_exports__["b"] = phrases;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__var__ = __webpack_require__("dTkA");


var _globals = {};
var _phrases = {};

/**
 * Returns Globals object
 * @param {string|null} key Optional key to return
 * @param {*} defaultValue Default value for key
 * @return {object|*} Globals object if no key is provided, otherwise associated value
 */
function globals() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var g = window.globals || _globals;
  return key !== null ? Object(__WEBPACK_IMPORTED_MODULE_0__var__["e" /* element */])(g, key, defaultValue) : g;
}

/**
 * Returns global Phrases object
 * @param {string|null} key Optional key to return
 * @param {*} defaultValue Default value for key
 * @return {object} Phrases object if no key is provided, otherwise associated value
 */
function phrases() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var g = globals('phrases') || _phrases;
  return key !== null ? Object(__WEBPACK_IMPORTED_MODULE_0__var__["e" /* element */])(g, key, defaultValue) : g;
}

/***/ }),

/***/ "UpRQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserInfo", function() { return UserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentUser", function() { return currentUser; });
/* harmony export (immutable) */ __webpack_exports__["ensureLoggedIn"] = ensureLoggedIn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modals__ = __webpack_require__("YdFU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_globals__ = __webpack_require__("TxBK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events__ = __webpack_require__("oHD7");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var UserInfo = function () {
	function UserInfo(data) {
		_classCallCheck(this, UserInfo);

		this._data = _extends({}, data);
	}

	_createClass(UserInfo, [{
		key: "id",
		get: function get() {
			return +this._data['id'];
		}
	}, {
		key: "roleId",
		get: function get() {
			return +this._data['role_id'];
		}
	}, {
		key: "isCustomer",
		get: function get() {
			return !!this._data['is_customer'];
		}
	}, {
		key: "url",
		get: function get() {
			return this._data['url'];
		}
	}, {
		key: "shortName",
		get: function get() {
			return this._data['short_name'];
		}
	}, {
		key: "fullName",
		get: function get() {
			return this._data['full_name'];
		}
	}, {
		key: "blogName",
		get: function get() {
			return this._data['blog_name'];
		}
	}, {
		key: "avatar",
		get: function get() {
			return this._data['avatar'];
		}
	}, {
		key: "avatarFull",
		get: function get() {
			return this._data['avatar_full'];
		}
	}, {
		key: "avatarExists",
		get: function get() {
			return !!this._data['avatar_exists'];
		}
	}, {
		key: "level",
		get: function get() {
			return +this._data['level'];
		}
	}]);

	return UserInfo;
}();

var data = Object(__WEBPACK_IMPORTED_MODULE_1__utils_globals__["a" /* globals */])('userInfo');

/**
 * Currently logged in user.
 * NULL means guest user.
 * @type {UserInfo}
 */
var currentUser = data ? new UserInfo(data) : null;

/**
 * Executes given callback with logged in user.
 * If user is logged in - callback will be called immediately.
 * If not logged in - modal window will be shown and callback will be called only if user logged in.
 * @param callback Accepts {@link UserInfo} instance
 */
function ensureLoggedIn(callback) {
	if (window.IS_LOGGED_IN) {
		callback(currentUser);
	} else {
		__WEBPACK_IMPORTED_MODULE_0__modals__["MODAL_LOGIN"].show(function (result) {
			if (result) {
				// currentUser has been already updated in event handler below
				callback(currentUser);
			}
		});
	}
}

// catch global event and update user info
__WEBPACK_IMPORTED_MODULE_2__events__["a" /* GlobalEvents */].USER_LOGGED_IN.on(function (user) {
	currentUser = new UserInfo(user);
	console.log('user logged in', currentUser);

	// update currentUser variable
	// (do it explicitly because the first line of current function does not update the global object)
	window.zde.currentUser = currentUser;

	// update legacy variables
	window.IS_LOGGED_IN = true;
	window.USER_ID = currentUser.id;
	window.USER_NAME = currentUser.fullName;
	window.USER_BLOG_NAME = currentUser.blogName;
	window.IS_CUSTOMER = currentUser.isCustomer;
});

/***/ }),

/***/ "Vmcm":
/***/ (function(module, exports) {

module.exports = "<!-- ko if: columns -->\n\t<!-- ko if: reviewCols()[0]().length > 0 -->\n\t\t<!-- Ordinary foreach results full rerender every time something is added to a subarray, so duplicate -->\n\t\t<div class=\"reviews-column\" rel=\"review-col\" data-bind=\"foreach: reviewCols()[0]\">\n\t\t\t<div class=\"review-item\" data-bind=\"component: {name: 'review-item', params: $data},\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tattr: {id: 'review-list-item-' + $data.id},\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tcss: {'body-less': $data.isBodyLess}\">\n\t\t\t</div>\n\t\t</div>\n\t\t<!-- ko if: columnsCount >= 2 -->\n\t\t<div class=\"reviews-column\" rel=\"review-col\" data-bind=\"foreach: reviewCols()[1]\">\n\t\t\t<div class=\"review-item\" data-bind=\"component: {name: 'review-item', params: $data},\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tattr: {id: 'review-list-item-' + $data.id},\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcss: {'body-less': $data.isBodyLess}\">\n\t\t\t</div>\n\t\t</div>\n\t\t<!-- /ko -->\n\t\t<!-- ko if: columnsCount >= 3 -->\n\t\t<div class=\"reviews-column\" rel=\"review-col\" data-bind=\"foreach: reviewCols()[2]\">\n\t\t\t<div class=\"review-item\" data-bind=\"component: {name: 'review-item', params: $data},\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tattr: {id: 'review-list-item-' + $data.id},\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcss: {'body-less': $data.isBodyLess}\">\n\t\t\t</div>\n\t\t</div>\n\t\t<!-- /ko -->\n\t\t<!-- ko if: columnsCount >= 4 -->\n\t\t<div class=\"reviews-column\" rel=\"review-col\" data-bind=\"foreach: reviewCols()[3]\">\n\t\t\t<div class=\"review-item\" data-bind=\"component: {name: 'review-item', params: $data},\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tattr: {id: 'review-list-item-' + $data.id},\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcss: {'body-less': $data.isBodyLess}\">\n\t\t\t</div>\n\t\t</div>\n\t\t<!-- /ko -->\n\t\t<!-- ko if: columnsCount >= 5 -->\n\t\t<div class=\"reviews-column\" rel=\"review-col\" data-bind=\"foreach: reviewCols()[4]\">\n\t\t\t<div class=\"review-item\" data-bind=\"component: {name: 'review-item', params: $data},\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tattr: {id: 'review-list-item-' + $data.id},\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcss: {'body-less': $data.isBodyLess}\">\n\t\t\t</div>\n\t\t</div>\n\t\t<!-- /ko -->\n\t<!-- /ko -->\n\t<!-- ko else -->\n\t\t<!-- ko if: !isLoading -->\n\t\t\t<div class=\"no-reviews-found\" style=\"display: none\" data-bind=\"visible: reviewCols[0]().length == 0\">\n\t\t\t\t<div class=\"big\">Извините :(</div>\n\t\t\t\t<div class=\"small\">В данном разделе отзывов пока нет</div>\n\t\t\t\t<div class=\"no-reviews-image\">\n\t\t\t\t\t<div class=\"img\"></div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t<!-- /ko -->\n\t<!-- /ko -->\n<!-- /ko -->\n<!-- ko else -->\n\t<!-- ko if: reviews().length > 0 -->\n\t<div class=\"reviews-plain-list\" data-bind=\"foreach: reviews\">\n\t\t<div class=\"review-item\" data-bind=\"component: {name: 'review-item', params: $data},\n\t\t\t\t\t\t\t\t\t\t\tattr: {id: 'review-list-item-' + $data.id},\n\t\t\t\t\t\t\t\t\t\t\tcss: {'body-less': $data.isBodyLess}\">\n\t\t</div>\n\t</div>\n\t<!-- /ko -->\n\t<!-- ko else -->\n\t\t<!-- ko if: !isLoading -->\n\t\t\t<div class=\"no-reviews-found\" style=\"display: none\" data-bind=\"visible: reviews().length == 0\">\n\t\t\t\t<div class=\"big\">Извините :(</div>\n\t\t\t\t<div class=\"small\">В данном разделе отзывов пока нет</div>\n\t\t\t\t<div class=\"no-reviews-image\">\n\t\t\t\t\t<div class=\"img\"></div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t<!-- /ko -->\n\t<!-- /ko -->\n<!-- /ko -->\n"

/***/ }),

/***/ "X0GP":
/***/ (function(module, exports) {

module.exports = _;

/***/ }),

/***/ "XRua":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export buildUrl */
/* harmony export (immutable) */ __webpack_exports__["c"] = buildQuery;
/* harmony export (immutable) */ __webpack_exports__["a"] = addQuery;
/* harmony export (immutable) */ __webpack_exports__["b"] = appendQuery;
/* unused harmony export query */
/* unused harmony export hashQuery */
/* harmony export (immutable) */ __webpack_exports__["d"] = decodeQueryString;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * This script adds some additional methods to window.location
 *  buildQuery      Helper method for constricting query strings
 *  query           location.query manipulator
 *  hashQuery       location.hash manipulator
 */

var location = window.location;

function buildUrl(pathname, queryString) {
	if (!queryString) {
		return pathname;
	}
	queryString = '' + queryString;
	if (!queryString.startsWith('?')) {
		queryString = '?' + queryString;
	}
	return pathname + queryString;
}

/**
 * Builds query string from given object
 * @param {object} queryData
 * @param {boolean} [numeric_prefix]
 * @return {string}
 */
function buildQuery(queryData, numeric_prefix) {
	var value = void 0,
	    key = void 0,
	    tmp = [];
	var arg_separator = "&";

	for (key in queryData) {
		if (!queryData.hasOwnProperty(key)) {
			continue;
		}
		value = queryData[key];
		if (numeric_prefix && !isNaN(key)) {
			key = String(numeric_prefix) + key;
		}
		var _query = http_build_query_helper(urlencode(key), value, arg_separator);
		if (_query !== '') {
			tmp.push(_query);
		}
	}

	return tmp.join(arg_separator);
}

/**
 * Appends given query data to given URL
 * @param {string} url
 * @param {object} queryData
 * @return {string} New url
 */
function addQuery(url, queryData) {
	var q = buildQuery(queryData);
	url = '' + url;
	var m = /^([^?#]*)(\?[^#]+)?(#.+)?$/.exec(url);
	if (!m) {
		return url + '?' + q;
	}
	return (m[1] || '') + (m[2] ? m[2] + '&' + q : '?' + q) + (m[3] || '');
}

/**
 * Appends given query data to given query string
 * @param {string} queryString
 * @param {object} queryData
 * @return {string} New query string
 */
function appendQuery(queryString, queryData) {
	var q = buildQuery(queryData);
	if (!q) {
		return queryString;
	}
	var str = '' + queryString;
	return str.length > 0 ? str + '&' + q : q;
}

/**
 * Manipulates <code>location.search</code> as an object.<br/>
 * With no arguments - returns the whole <code>location.search</code> object.<br/>
 * With only key argument - returns value for this key.<br/>
 * With key and value arguments (or only key as object) - updates <code>location.search</code> with new value
 * @param [key] The key to set. Can be an object, so the value is not needed
 * @param [value] The value to set
 * @param [extend] TRUE to extend current <code>location.search</code> object, or FALSE to replace it. Default is TRUE
 * @returns {Object|String}
 */
function query(key, value, extend) {
	return processQuery('search', key, value, extend);
}

/**
 * Manipulates <code>location.hash</code> as an object.<br/>
 * With no arguments - returns the whole <code>location.hash</code> object.<br/>
 * With only key argument - returns value for this key.<br/>
 * With key and value arguments (or only key as object) - updates <code>location.hash</code> with new value
 * @param [key] The key to set. Can be an object, so the value is not needed
 * @param [value] The value to set
 * @param [extend] TRUE to extend current <code>location.hash</code> object, or FALSE to replace it. Default is TRUE
 * @returns {Object|String}
 */
function hashQuery(key, value, extend) {
	return processQuery('hash', key, value, extend);
}

function processQuery(type, key, value, extend) {
	var queryData = decodeQueryString(location[type].substring(1));
	if (key !== undefined) {
		var isObj = (typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'object';

		if (value === undefined && !isObj) {
			// return value
			return queryData[key] === undefined ? null : queryData[key];
		} else if (!isObj) {
			if (extend === undefined) extend = true;

			// set value to key
			var k = key.toString();
			key = {};
			key[k] = value;
		}

		if (extend) {
			$.extend(queryData, key);
		} else {
			queryData = key;
		}

		// clear data
		var newData = {};
		$.each(queryData, function (key, value) {
			if (value) newData[key] = value;
		});
		queryData = newData;

		location[type] = buildQuery(queryData);
	}
	return queryData;
}

/**
 * Decodes query string like 'a=one&b=two&c[]=three' and returns an object
 * @param string
 * @return {Object}
 */
function decodeQueryString(string) {
	var glue1 = '=',
	    glue2 = '&',
	    array = {},
	    // holds result
	array2 = String(string).replace(/^&?([\s\S]*?)&?$/, '$1').split(glue2),
	    i = void 0,
	    j = void 0,
	    chr = void 0,
	    tmp = void 0,
	    key = void 0,
	    value = void 0,
	    bracket = void 0,
	    keys = void 0,
	    evalStr = void 0,
	    fixStr = function fixStr(str) {
		return decodeURIComponent(str).replace(/([\\"'])/g, '\\$1').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\+/g, ' ');
	};

	for (i = 0; i < array2.length; i++) {
		tmp = array2[i].split(glue1);
		if (tmp.length < 2) {
			tmp = [tmp, ''];
		}
		key = fixStr(tmp[0]);
		value = fixStr(tmp[1]);
		while (key.charAt(0) === ' ') {
			key = key.substr(1);
		}
		if (key.indexOf('\0') !== -1) {
			key = key.substr(0, key.indexOf('\0'));
		}
		if (key && key.charAt(0) !== '[') {
			keys = [];
			bracket = 0;
			for (j = 0; j < key.length; j++) {
				if (key.charAt(j) === '[' && !bracket) {
					bracket = j + 1;
				} else if (key.charAt(j) === ']') {
					if (bracket) {
						if (!keys.length) {
							keys.push(key.substr(0, bracket - 1));
						}
						keys.push(key.substr(bracket, j - bracket));
						bracket = 0;
						if (key.charAt(j + 1) !== '[') {
							break;
						}
					}
				}
			}
			if (!keys.length) {
				keys = [key];
			}
			for (j = 0; j < keys[0].length; j++) {
				chr = keys[0].charAt(j);
				if (chr === ' ' || chr === '.' || chr === '[') {
					keys[0] = keys[0].substr(0, j) + '_' + keys[0].substr(j + 1);
				}
				if (chr === '[') {
					break;
				}
			}
			evalStr = 'array';
			for (j = 0; j < keys.length; j++) {
				key = keys[j];
				if (key !== '' && key !== ' ' || j === 0) {
					key = "'" + key + "'";
				} else {
					key = eval(evalStr + '.push([]);') - 1;
				}
				evalStr += '[' + key + ']';
				if (j !== keys.length - 1 && eval('typeof ' + evalStr) === 'undefined') {
					eval(evalStr + ' = [];');
				}
			}
			evalStr += " = '" + value + "';\n";
			eval(evalStr);
		}
	}

	return array;
}

function urlencode(str) {
	str = (str + '').toString();
	return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
}

function http_build_query_helper(key, val, arg_separator) {
	var k = void 0,
	    tmp = [];
	if (val === true) {
		val = "1";
	} else if (val === false) {
		val = "0";
	}
	if (val !== null && val !== undefined && val !== '') {
		if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === "object") {
			var start = 0;
			for (k in val) {
				if (!val.hasOwnProperty(k)) {
					continue;
				}
				if (val[k] !== null) {
					var sk = void 0,
					    num = Number(k);
					if (!isNaN(num) && num - start === 0) {
						if (_typeof(val[k]) === "object") {
							sk = num;
						} else {
							sk = '';
						}
						start++;
					} else {
						sk = urlencode(k);
					}
					var part = http_build_query_helper(key + "[" + sk + "]", val[k], arg_separator);
					if (part) {
						tmp.push(part);
					}
				}
			}
			return tmp.join(arg_separator);
		} else if (typeof val !== "function") {
			return key + "=" + urlencode(val);
		} else {
			throw new Error('There was an error processing for http_build_query().');
		}
	} else {
		return '';
	}
}

/***/ }),

/***/ "Y/PR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YdFU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_LOGIN", function() { return MODAL_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_ASK_REDIRECT", function() { return MODAL_ASK_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_CRITICAL_NEWS", function() { return MODAL_CRITICAL_NEWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_REVIEW", function() { return MODAL_REVIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_REVIEW_EDIT", function() { return MODAL_REVIEW_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_QUESTION_EDIT", function() { return MODAL_QUESTION_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_REVIEW_COMMENT_EDIT", function() { return MODAL_REVIEW_COMMENT_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_CREATE_COMPUTER_ORDER", function() { return MODAL_CREATE_COMPUTER_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_ORDER_PAGE", function() { return MODAL_FILIALIST_ORDER_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_EXCLUDE_FROM_PARCEL", function() { return MODAL_FILIALIST_EXCLUDE_FROM_PARCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_FREE_ORDERS_EDIT", function() { return MODAL_FILIALIST_FREE_ORDERS_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_CREATE_TODO", function() { return MODAL_FILIALIST_CREATE_TODO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIIST_REASSIGN_PACKAGES_TO_CUSTOMERS", function() { return MODAL_FILIALIIST_REASSIGN_PACKAGES_TO_CUSTOMERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_CHANGE_ASSIGNMENT_CUSTOMER", function() { return MODAL_FILIALIST_CHANGE_ASSIGNMENT_CUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_EDIT_ASSIGNMENT", function() { return MODAL_FILIALIST_EDIT_ASSIGNMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_GET_ASSIGNMENT_MEEST_DATA", function() { return MODAL_FILIALIST_GET_ASSIGNMENT_MEEST_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_BATCH_PAYMENT", function() { return MODAL_FILIALIST_BATCH_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_SET_PACKAGE_KINDS", function() { return MODAL_FILIALIST_SET_PACKAGE_KINDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_FILIALIST_SET_MEEST_ADDRESS_ALIASES", function() { return MODAL_FILIALIST_SET_MEEST_ADDRESS_ALIASES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_ADMIN_REPLENISH_BALANCE", function() { return MODAL_ADMIN_REPLENISH_BALANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_ADMIN_BATCH_PAYMENT", function() { return MODAL_ADMIN_BATCH_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_ADMIN_IMPORT_BANK_STATEMENT", function() { return MODAL_ADMIN_IMPORT_BANK_STATEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_ADMIN_VALIDATE_INVOICE_CSV", function() { return MODAL_ADMIN_VALIDATE_INVOICE_CSV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_ADMIN_SHOP_BANK_STATEMENT_KEYWORDS", function() { return MODAL_ADMIN_SHOP_BANK_STATEMENT_KEYWORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_PACKAGE_INFO", function() { return MODAL_PACKAGE_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MODAL_SELECT_SHOP_CATEGORY", function() { return MODAL_SELECT_SHOP_CATEGORY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_modal__ = __webpack_require__("rItL");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/*
This file contains shortcuts for different kinds of modals
 */



var MODAL_LOGIN = {
	/**
  * @param {Function} onClose Callback accepts one parameter of type {object} - dialog's result
  * @return {ZDialog}
  */
	show: function show() {
		var onClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('login', null, { onClose: onClose });
	}
};

var MODAL_ASK_REDIRECT = {
	/**
  * @param {object} data
  * @return {ZDialog}
  */
	show: function show() {
		var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('ask_redirect', data, {
			modal: true
		});
	}
};

var MODAL_CRITICAL_NEWS = {
	/**
  * @param {number} id News ID
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(id) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('critical_news', { id: id }, {
			modal: true,
			onClose: onClose
		});
	}
};

var MODAL_REVIEW = {
	/**
  * @param {number} id
  * @param {number} index
  * @param {*} filter
  * @return {ZDialog}
  */
	show: function show(id) {
		var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
		var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('review', { id: id, index: index, filter: filter }, { fullscreen: true });
	}
};

var MODAL_REVIEW_EDIT = {
	/**
  * @param {number} id
  * @param {number} packageId
  * @param {Object} initialValues
 * @param {Function} onClose
 * @return {ZDialog}
  */
	show: function show(id) {
		var packageId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
		var initialValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
		var onClose = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

		var data = _extends({
			id: id,
			package_id: packageId
		}, initialValues);

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('review_edit', data, { onClose: onClose });
	}
};

var MODAL_QUESTION_EDIT = {
	/**
  * @param {number} id
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(id) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('question_edit', { id: id }, { onClose: onClose });
	}
};

var MODAL_REVIEW_COMMENT_EDIT = {
	/**
  * @param {number} id
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(id) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('review_comment_edit', { id: id }, { width: 650, onClose: onClose });
	}
};

var MODAL_CREATE_COMPUTER_ORDER = {
	/**
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show() {
		var onClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('create_computer_order', {}, { width: 780, onClose: onClose });
	}
};

var MODAL_FILIALIST_ORDER_PAGE = {
	/**
  * @param {number} id Package ID
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(id) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_order_page', { id: id }, { type: 'window', onClose: onClose });
	}
};

var MODAL_FILIALIST_EXCLUDE_FROM_PARCEL = {
	/**
  * @param {number} id Package ID
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(id) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_exclude_from_parcel', { id: id }, { width: 470, onClose: onClose });
	}
};

var MODAL_FILIALIST_FREE_ORDERS_EDIT = {
	/**
  * @param {number} customerId
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(customerId) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_free_orders_edit', { customer_id: customerId }, { width: 1300, onClose: onClose });
	}
};

var MODAL_FILIALIST_CREATE_TODO = {
	/**
  * @param {number} id
  * @param {string} type
  * @param {Function} onClose
 * @return {ZDialog}
  */
	show: function show(id, type) {
		var onClose = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_create_todo', { id: id, type: type }, { width: 600, onClose: onClose });
	}
};

var MODAL_FILIALIIST_REASSIGN_PACKAGES_TO_CUSTOMERS = {
	/**
  * @param {number[]} ids
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(ids) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_reassign_packages_to_customers', { ids: ids }, { width: 1800, onClose: onClose });
	}
};

var MODAL_FILIALIST_CHANGE_ASSIGNMENT_CUSTOMER = {
	/**
  * @param {Function} onClose
  * @returns {ZDialog}
  */
	show: function show() {
		var onClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_change_assignment_customer', null, { width: 900, onClose: onClose });
	}
};

var MODAL_FILIALIST_EDIT_ASSIGNMENT = {
	/**
  * @param {number} id
  * @param {Function} onClose
  * @returns {ZDialog}
  */
	show: function show(id) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_edit_assignment', { id: id }, { width: 500, onClose: onClose });
	}
};

var MODAL_FILIALIST_GET_ASSIGNMENT_MEEST_DATA = {
	/**
  * @param {string} id
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(id) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_get_assignment_meest_data', { id: id }, { width: 450, onClose: onClose });
	}
};

var MODAL_FILIALIST_BATCH_PAYMENT = {
	/**
  * @param {array} ids
 * $param {string} account
  * @param {number} rate
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(ids, account, rate) {
		var onClose = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_batch_payment', { ids: ids, account: account, rate: rate }, { width: 400, onClose: onClose });
	}
};

var MODAL_FILIALIST_SET_PACKAGE_KINDS = {
	/**
  * @param {number[]} ids
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(ids) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_set_package_kinds', { ids: ids }, { width: 900, onClose: onClose });
	}
};

var MODAL_FILIALIST_SET_MEEST_ADDRESS_ALIASES = {
	/**
  * @param {string[]} cities
  * @param {Object[]} streets
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(cities, streets) {
		var onClose = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

		var data = encodeURIComponent(JSON.stringify({ cities: cities, streets: streets }));
		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('filialist_set_meest_address_aliases', { data: data }, { onClose: onClose });
	}
};

var MODAL_ADMIN_REPLENISH_BALANCE = {
	/**
  * @param {number} pendingReplenihmentId
  * @param {number} boundBankTransactionId
  * @param {number} suggestionBondId
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(pendingReplenihmentId) {
		var boundBankTransactionId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
		var suggestionBondId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
		var onClose = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

		Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('admin_replenish_balance', {
			pending_replenihment_id: pendingReplenihmentId,
			bound_bank_transaction_id: boundBankTransactionId,
			suggestion_bond_id: suggestionBondId
		}, { onClose: onClose });
	}
};

var MODAL_ADMIN_BATCH_PAYMENT = {
	/**
  * @param {string} accountSource
  * @param {string} accountTarget
  * @param {number} amount
  * @param {number} rate
  * @param {number[]} groupIds
  * @param {number[]} boundBankTransactionIds
  * @param {number} suggestionBondId
  * @param {Function} onClose
  */
	show: function show(accountSource, accountTarget, amount, rate, groupIds, boundBankTransactionIds) {
		var suggestionBondId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
		var onClose = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;

		Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('admin_batch_payment', {
			account_source: accountSource,
			account_target: accountTarget,
			amount: amount,
			rate: rate,
			group_ids: groupIds,
			bound_bank_transaction_ids: boundBankTransactionIds,
			suggestion_bond_id: suggestionBondId
		}, { width: 500, onClose: onClose });
	}
};

var MODAL_ADMIN_IMPORT_BANK_STATEMENT = {
	/**
  * @param {Function} onClose
  * @returns {ZDialog}
  */
	show: function show() {
		var onClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('admin_import_bank_statement', {}, { width: 800, onClose: onClose });
	}
};

var MODAL_ADMIN_VALIDATE_INVOICE_CSV = {
	/**
  * @param {string | null} name
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show() {
		var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('admin_validate_invoice_csv', { name: name }, { width: 500, onClose: onClose });
	}
};

var MODAL_ADMIN_SHOP_BANK_STATEMENT_KEYWORDS = {
	/**
  * @returns {ZDialog}
  */
	show: function show() {
		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('admin_shop_bank_statement_keywords', {}, { width: 1200 });
	}
};

var MODAL_PACKAGE_INFO = {
	/**
  * @param {number} id Package ID
  * @param {Function} onClose
  * @return {ZDialog}
  */
	show: function show(id) {
		var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('package_info', { id: id }, { onClose: onClose });
	}
};

var MODAL_SELECT_SHOP_CATEGORY = {
	show: function show(onClose) {
		return Object(__WEBPACK_IMPORTED_MODULE_0__utils_modal__["a" /* showModalIframe */])('select_shop_category', {}, { width: 550, onClose: onClose });
	}
};

/***/ }),

/***/ "YnTO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = checkIsIframe;
/* harmony export (immutable) */ __webpack_exports__["c"] = isMobile;
/* harmony export (immutable) */ __webpack_exports__["d"] = isTouchScreen;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WEBP_FEATURES; });
/* harmony export (immutable) */ __webpack_exports__["e"] = isWebpFeatureSupported;
/**
 * @return {boolean} TRUE if current window is an iframe window
 */
function checkIsIframe() {
	return window !== window.top;
}

var _isMobile = 'orientation' in window || navigator.userAgent.indexOf('IEMobile') !== -1;
var _isTouchScreen = 'ontouchstart' in window || navigator.msMaxTouchPoints;

function isMobile() {
	return _isMobile;
}

function isTouchScreen() {
	return _isTouchScreen;
}

var WEBP_FEATURES = {
	LOSSY: 'lossy',
	LOSSLESS: 'lossless',
	ALPHA: 'alpha',
	ANIMATION: 'animation'
};

function isWebpFeatureSupported(feature) {
	return new Promise(function (resolve, reject) {
		if (!Object.values(WEBP_FEATURES).includes(feature)) {
			reject('Invalid feature name');
			return;
		}

		var kTestImages = {
			lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
			lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
			alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
			animation: "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
		};
		var img = new Image();
		img.onload = function () {
			var result = img.width > 0 && img.height > 0;
			resolve(result);
		};
		img.onerror = function () {
			resolve(false);
		};
		img.src = "data:image/webp;base64," + kTestImages[feature];
	});
}

/*export class MobileDetect {
	static Android = navigator.userAgent.match(/Android/i);
	static BlackBerry = navigator.userAgent.match(/BlackBerry/i);
	static iOS = navigator.userAgent.match(/iPhone|iPad|iPod/i);
	static Opera = navigator.userAgent.match(/Opera Mini/i);
	static Windows = navigator.userAgent.match(/IEMobile/i);
	static Any = MobileDetect.Android || MobileDetect.BlackBerry || MobileDetect.iOS || MobileDetect.Opera || MobileDetect.Windows;
}*/

/***/ }),

/***/ "cK6l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReviewListMobile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reviewlist__ = __webpack_require__("otQ7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reviewitemmobile__ = __webpack_require__("FZjg");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var ReviewListMobile = function (_ReviewList) {
    _inherits(ReviewListMobile, _ReviewList);

    function ReviewListMobile() {
        _classCallCheck(this, ReviewListMobile);

        return _possibleConstructorReturn(this, (ReviewListMobile.__proto__ || Object.getPrototypeOf(ReviewListMobile)).apply(this, arguments));
    }

    _createClass(ReviewListMobile, [{
        key: "_prepareItems",

        /**
            * @param {array} items
         * @return {array}
            * @private
            */
        value: function _prepareItems(items) {
            var _this2 = this;

            return items.map(function (r) {
                r.parent = _this2;
                return new __WEBPACK_IMPORTED_MODULE_1__reviewitemmobile__["a" /* ReviewItemMobile */](r);
            });
        }

        /**
         * @param {ReviewItem} item
         * @private
         */

    }, {
        key: "_handleItemClick",
        value: function _handleItemClick(item) {
            if (!this.isDetails) {
                window.open(item.data().url, '_blank');
            }
        }
    }]);

    return ReviewListMobile;
}(__WEBPACK_IMPORTED_MODULE_0__reviewlist__["a" /* ReviewList */]);

/***/ }),

/***/ "dTkA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isset */
/* harmony export (immutable) */ __webpack_exports__["e"] = element;
/* unused harmony export elementOrDefault */
/* harmony export (immutable) */ __webpack_exports__["f"] = elementOrDash;
/* harmony export (immutable) */ __webpack_exports__["g"] = orDefault;
/* harmony export (immutable) */ __webpack_exports__["c"] = asNumber;
/* harmony export (immutable) */ __webpack_exports__["b"] = asBoolean;
/* harmony export (immutable) */ __webpack_exports__["d"] = asString;
/* harmony export (immutable) */ __webpack_exports__["h"] = trim;
/* harmony export (immutable) */ __webpack_exports__["a"] = asArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lib_underscore__);


/**
 * Is a given variable defined and has value?
 * @param {*} val
 * @return {boolean} <code>false</code> if given value is <code>undefined</code> or <code>null</code>, otherwise <code>true</code>
 */
function isset(val) {
  return !__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isUndefined(val) && !__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isNull(val);
}

/**
 * Returns object's property or array's index if exists and default value otherwise
 * @param {object|array} object Inspected object or array
 * @param {string|number} key Property name for objects, numeric index for arrays
 * @param {*} defaultValue
 * @return {*}
 */
function element(object, key) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.has(object, key) ? object[key] : defaultValue;
}

/**
 * Returns object's property or array's index if exists and is not <code>null</code> or default value otherwise
 * @param {object|array} object Inspected object or array
 * @param {string|number} key Property name for objects, numeric index for arrays
 * @param {*} defaultValue
 * @return {*}
 */
function elementOrDefault(object, key) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.has(object, key) && object[key] !== null ? object[key] : defaultValue;
}

/**
 * Returns object's property or array's index if exists and is not <code>null</code> or "&mdash;" value otherwise
 * @param {object|array} object Inspected object or array
 * @param {string|number} key Property name for objects, numeric index for arrays
 * @param {*} defaultValue
 * @return {*}
 */
function elementOrDash(object, key) {
  return elementOrDefault(object, key, '&mdash;');
}

/**
 * Returns value if it's not <code>undefined</code> or <code>null</code>, otherwise defaultValue
 * @param {*} value
 * @param {*} defaultValue
 * @return {*}
 */
function orDefault(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return isset(value) ? value : defaultValue;
}

/**
 * Converts given value to number using standard javascript converter: <code>+value</code>
 * @param {*} value Input value
 * @param {number} defaultValue
 * @return {number} Either converted value if it's not <code>NaN</code> and default value otherwise
 */
function asNumber(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  value = +value;
  return !isNaN(value) ? value : 0;
}

/**
 * Converts given value to boolean using such algo:
 * - string <code>"0"</code> results in <code>false</code>;
 * - string <code>"false"</code> results in <code>false</code>;
 * - string <code>"null"</code> results in <code>false</code>;
 * - empty object results in <code>false</code>;
 * - empty array results in <code>false</code>;
 * - other values go through standard javascript converter: <code>!!value</code>
 * @param {*} value Input value
 * @return {boolean} Converted value
 */
function asBoolean(value) {
  if (__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isBoolean(value)) return value;
  if (value === '0') return false;
  if (value === 'false') return false;
  if (value === 'null') return false;
  if (__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isObject(value) && __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isEmpty(value)) return false;
  if (__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isArray(value) && __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isEmpty(value)) return false;
  return !!value;
}

/**
 * Converts given value to string using standard javascript converter: <code>''+value</code>
 * except that <code>null</code> and <code>undefined</code> values will be converted to empty string.
 * @param {*} value Input value
 * @return {string} Converted value
 */
function asString(value) {
  if (value === null || __WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isUndefined(value)) return '';
  return '' + value;
}

/**
 * Converts given value to string using {@link asString()} and trims whitespace characters.
 * @param {string|*} value
 * @return {string} Converted and trimmed value
 */
function trim(value) {
  return asString(value).trim();
}

/**
 * If input value is an array - it will be returned as is.
 * In other cases input value will be converted to string and either split with given delimiter
 * or just returned as a single array element.
 * @param {array|string} value
 * @param {string} delimiter
 * @return {array}
 */
function asArray(value) {
  var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!value) return [];
  if (__WEBPACK_IMPORTED_MODULE_0_lib_underscore___default.a.isArray(value)) return value;
  value = asString(value);
  return delimiter ? value.split(delimiter) : [value];
}

/***/ }),

/***/ "dydC":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("oN+n")(__webpack_require__("i8fT"))

/***/ }),

/***/ "ejlv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_urlconverter_jquery_urlconverter__ = __webpack_require__("dydC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendor_urlconverter_jquery_urlconverter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__vendor_urlconverter_jquery_urlconverter__);


/***/ }),

/***/ "fokk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["createIframeDialog"] = createIframeDialog;
/* harmony export (immutable) */ __webpack_exports__["createHtmlDialog"] = createHtmlDialog;
/* harmony export (immutable) */ __webpack_exports__["openHtmlDialog"] = openHtmlDialog;
/* harmony export (immutable) */ __webpack_exports__["createWindowDialog"] = createWindowDialog;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dialogManager", function() { return dialogManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dialog_less__ = __webpack_require__("vBks");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dialog_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__dialog_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_underscore__ = __webpack_require__("X0GP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lib_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_knockout__ = __webpack_require__("7fPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lib_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_logger__ = __webpack_require__("5wqq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils__ = __webpack_require__("YnTO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_var__ = __webpack_require__("dTkA");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








var logger = Object(__WEBPACK_IMPORTED_MODULE_3__utils_logger__["a" /* newLogger */])('ZDialog');

/**
 * Creates new dialog with IFrame with given url
 * @param {string} url IFrame url
 * @param {object} options ZDialog Options. See {@link ZDialog.defaults}
 * @return {ZDialog}
 */
function createIframeDialog(url) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	return newDialog(_extends({ content: url, type: 'iframe', __width: 800 }, options));
}

/**
 * Creates new dialog instance.
 * autoOpen option is false by default, so you should either call open() method
 * or override autoOpen option
 * @param {*} content HTML content. Can be either valid HTML string, or DOM node, or jQuery object
 * @param {object} options ZDialog Options. See {@link ZDialog.defaults}
 * @return {ZDialog} Dialog instance
 */
function createHtmlDialog(content) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	return newDialog(_extends({ content: content, type: 'html', showCloseButton: true }, options));
}

/**
 * The same as {@link createHtmlDialog()} but with autoOpen enabled
 * @param {*} content HTML content
 * @param {object} options ZDialog options
 * @return {ZDialog} Dialog instance
 */
function openHtmlDialog(content) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	return createHtmlDialog(content, _extends({ autoOpen: true }, options));
}

/**
 * Creates new dialog as new window with given url
 * @param {string} url IFrame url
 * @param {object} options ZDialog Options. See {@link ZDialog.defaults}
 * @return {ZDialog}
 */
function createWindowDialog(url) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	return newDialog(_extends({ content: url, type: 'window' }, options));
}

// add some helper functions to jQuery
$.extend($.fn, {
	/**
  * Calls {@link openHtmlDialog()} with source element as content
  * @param {object} options ZDialog Options. See {@link ZDialog.defaults}
  */
	zdialog: function zdialog() {
		var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

		var $el = $(this);
		var $placeholder = $('<div style="display: none !important;"></div>').insertAfter($el);
		var isInDom = $el.closest(document.documentElement);
		var isVisible = $el.css('display') != 'none';
		if (isInDom) {
			$el.detach();
		}
		if (!isVisible) {
			$el.show();
		}
		var dialog = createHtmlDialog($el, options);
		dialog.onBeforeClose(function () {
			$el.detach();
		});
		dialog.onClose(function () {
			if (isInDom) {
				$el.insertAfter($placeholder);
			}
			if (!isVisible) {
				$el.hide();
			}
			$placeholder.remove();
		});
		dialog.open();
		$el.data('zdialogInstance', dialog);
		return this;
	},

	/**
  * Returns ZDialog instance for given element (if the dialog was created with {@link jQuery.fn.zdialog} function)
  * @return {ZDialog}
  */
	zdialogInstance: function zdialogInstance() {
		return this.data('zdialogInstance');
	}
});

// FOR TESTING
/*import {MODAL_ASK_REDIRECT, MODAL_CRITICAL_NEWS, MODAL_LOGIN, MODAL_PACKAGE_INFO, MODAL_REVIEW} from "../modals";
$('.logo').click(function(e) {
	e.preventDefault();
	const queue = [];
	const showNext = () => {
		if (queue.length > 0) {
			queue.shift()();
		}
	};
	const onOpen = () => {};
	// queue.push(() => MODAL_REVIEW.show(104625).onOpen(showNext));
	// queue.push(() => MODAL_LOGIN.show().onOpen(showNext));
	// queue.push(() => MODAL_PACKAGE_INFO.show(1803110691).onOpen(showNext));
	// queue.push(() => MODAL_ASK_REDIRECT.show().onOpen(showNext));
	// queue.push(() => MODAL_CRITICAL_NEWS.show(312).onOpen(showNext));
	queue.push(() => openHtmlDialog('<div rel="show-next" style="width: 400px; height: 400px; background: red;"></div>').onOpen(onOpen));
	queue.push(() => openHtmlDialog('<div style="width: 400px; height: 1000px; background: red;"></div>').onOpen(onOpen));
	queue.push(() => openHtmlDialog('<div style="width: 1500px; height: 400px; background: red;"></div>').onOpen(onOpen));
	queue.push(() => openHtmlDialog('<div style="width: 400px; height: 400px; background: red;"></div>', {fullscreen: true}).onOpen(onOpen));
	queue.push(() => openHtmlDialog('<div style="width: 2500px; height: 2500px; background: red;"></div>', {fullscreen: true}).onOpen(onOpen));
	showNext();

	$(document).on('click', '.zdialog-html > div', showNext);
});*/

/**
 * @param {object} options
 * @return {ZDialog}
 */
var newDialog = function newDialog(options) {
	return new ZDialog(options);
};

// force use newDialog function from top window
var key = '__zdialog_newDialog';
if (Object(__WEBPACK_IMPORTED_MODULE_4__utils_utils__["b" /* checkIsIframe */])()) {
	newDialog = window.top[key];
} else {
	window.top[key] = newDialog;
}

/**
 * Dialog class
 */

var ZDialog = function () {
	/** @type {JQuery.Callbacks} */

	/** @type {JQuery.Callbacks} */

	/** @type {HeightWatcher} */
	function ZDialog(options) {
		_classCallCheck(this, ZDialog);

		this._width = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable();
		this._height = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable();
		this._isModal = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._isCloseBtnVisible = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._isLoading = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._isOpened = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._isClosed = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._isHidden = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._contentHeight = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(0);
		this._iframeHeight = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(0);
		this._opened = false;
		this._onOpen = $.Callbacks();
		this._onClose = $.Callbacks();
		this._onBeforeClose = $.Callbacks();
		this._result = null;

		var o = _extends({}, ZDialog.defaults, options);

		this._name = o.name;
		this._o = o;
		this._isModal(!!o.modal);
		this._isCloseBtnVisible(!!o.showCloseButton);
		this._width(o.width);
		this._height(o.height);

		if (o.onOpen) {
			this._onOpen.add(o.onOpen);
		}
		if (o.onClose) {
			this._onClose.add(o.onClose);
		}

		if (o.autoOpen) {
			this.open();
		}
	}
	/** @type {JQuery.Callbacks} */


	// options


	_createClass(ZDialog, [{
		key: "open",
		value: function open() {
			var _this = this;

			if (this.isOpened) {
				return;
			}
			this._isClosed(false);
			this._isHidden(false);
			this._result = null;
			if (this.type === 'window') {
				this._wnd = window.open(this.content);
				this._wnd.addEventListener('DOMContentLoaded', function () {
					return _this._handleWindowReady();
				});
				this._wnd.onbeforeunload = function () {
					if (!_this.isClosed) {
						_this.close();
					}
				};
				this._isLoading(true);
			} else if (!dialogManager.isRegistered(this)) {
				if (this.isFullScreen) {
					this._width('');
					this._height('');
					this._contentHeight('');
					this._iframeHeight('');
				}
				if (this.type === 'iframe') {
					this._isLoading(true);
					if (!this.isAutoHeight) {
						this._contentHeight(this.height);
						this._iframeHeight(this.height);
					} else {
						this._contentHeight('');
					}
				} else {
					this._contentHeight(this.height);
					this._isOpened(true);
					setTimeout(function () {
						return _this._onOpen.fireWith(_this);
					}, 0);
				}
				dialogManager.register(this);
			} else if (this._isHidden()) {
				dialogManager.show(this);
			}
		}
	}, {
		key: "close",
		value: function close() {
			var _this2 = this;

			if (this.isClosed) {
				return;
			}
			this._onBeforeClose.fireWith(this, [this._result]);
			this._isOpened(false);
			this._isHidden(false);
			this._isClosed(true);
			if (this.type === 'window') {
				if (this._wnd) {
					this._wnd.close();
					window.top.focus();
					this._wnd = null;
					setTimeout(function () {
						return _this2._onClose.fireWith(_this2, [_this2._result]);
					}, 0);
				}
			} else if (dialogManager.isRegistered(this)) {
				if (this._heightWatcher) {
					this._heightWatcher.off();
				}
				dialogManager.unregister(this);
				setTimeout(function () {
					return _this2._onClose.fireWith(_this2, [_this2._result]);
				}, 0);
			}
		}
	}, {
		key: "hide",
		value: function hide() {
			if (this.type === 'window') {
				logger.error('Method is not supported for current dialog type');
			} else if (dialogManager.isRegistered(this)) {
				this._isOpened(false);
				this._isHidden(true);
				dialogManager.hide(this);
			}
		}
	}, {
		key: "closeWithResult",
		value: function closeWithResult(result) {
			this.result = result;
			this.close();
		}
	}, {
		key: "updatePosition",
		value: function updatePosition() {
			if (this.type === 'iframe') {
				this._contentHeight(this.iframeHeight);
			}
		}

		/** @return {string} */

	}, {
		key: "handleIframeLoad",
		value: function handleIframeLoad(item, e) {
			var _this3 = this;

			logger.log('loaded', e);
			this._isLoading(false);

			if (!this.isFullScreen && this.isAutoHeight) {
				this._heightWatcher = new HeightWatcher(e.target, function (newHeight) {
					logger.log("new height = " + newHeight);
					_this3._iframeHeight(newHeight);
					if (!_this3.contentHeight) {
						_this3._contentHeight(newHeight);
					}
					_this3._isOpened(true);
					setTimeout(function () {
						return _this3._onOpen.fireWith(_this3);
					}, 0);
				});
			} else {
				this._isOpened(true);
				setTimeout(function () {
					return _this3._onOpen.fireWith(_this3);
				}, 0);
			}

			// inject this instance to iframe
			e.target.contentWindow.dialogInstance = this;

			// apply special classes
			$(e.target.contentWindow.document.body).toggleClass('zdialog-layout-modal', this.isModal).toggleClass('zdialog-layout-autoheight', this.isAutoHeight).toggleClass('zdialog-layout-fullscreen', this.isFullScreen);

			// triger event inside iframe
			e.target.contentWindow.$(e.target.contentWindow.document).trigger('zdialog-shown');
		}
	}, {
		key: "_handleWindowReady",
		value: function _handleWindowReady(e) {
			var _this4 = this;

			logger.log('loaded', e);
			this._isLoading(false);
			this._isOpened(true);

			// inject this instance to iframe
			this._wnd.dialogInstance = this;
			$(this._wnd.document.body).addClass('zdialog-layout-window');

			setTimeout(function () {
				return _this4._onOpen.fireWith(_this4);
			}, 0);
		}
	}, {
		key: "handleCloseClick",
		value: function handleCloseClick(item, e) {
			var $target = $(e.target);
			if ($target.is('[data-dialog-result]')) {
				this.result = $target.data('dialogResult');
			}
			this.close();
		}
	}, {
		key: "handleBackdropClick",
		value: function handleBackdropClick() {
			if (dialogManager.isTopmost(this) && !this.isModal) {
				this.close();
			}
		}
	}, {
		key: "onOpen",
		value: function onOpen(callback) {
			this._onOpen.add(callback);
		}
	}, {
		key: "offOpen",
		value: function offOpen(callback) {
			this._onOpen.remove(callback);
		}
	}, {
		key: "onClose",
		value: function onClose(callback) {
			this._onClose.add(callback);
		}
	}, {
		key: "offClose",
		value: function offClose(callback) {
			this._onClose.remove(callback);
		}
	}, {
		key: "onBeforeClose",
		value: function onBeforeClose(callback) {
			this._onBeforeClose.add(callback);
		}
	}, {
		key: "offBeforeClose",
		value: function offBeforeClose(callback) {
			this._onBeforeClose.remove(callback);
		}
	}, {
		key: "name",
		get: function get() {
			return this._name;
		}

		/** @return {string} */

	}, {
		key: "type",
		get: function get() {
			return this._o.type;
		}

		/** @return {string} */

	}, {
		key: "content",
		get: function get() {
			return this._o.content;
		}

		/** @return {string} */

	}, {
		key: "title",
		get: function get() {
			return this._o.title;
		}

		/** @return {number} */

	}, {
		key: "width",
		get: function get() {
			return this._width();
		}

		/** @return {number|string} */

	}, {
		key: "height",
		get: function get() {
			return this._height();
		}

		/** @return {number|string} */

	}, {
		key: "minWidth",
		get: function get() {
			return this._o.minWidth;
		}

		/** @return {number|string} */

	}, {
		key: "maxWidth",
		get: function get() {
			return this._o.maxWidth;
		}

		/** @return {number|string} */

	}, {
		key: "contentWidth",
		get: function get() {
			return this._width();
		}

		/** @return {number|string} */

	}, {
		key: "contentHeight",
		get: function get() {
			return this._contentHeight();
		}

		/** @return {number} */

	}, {
		key: "iframeHeight",
		get: function get() {
			return this._iframeHeight();
		}

		/** @return {boolean} */

	}, {
		key: "isLoading",
		get: function get() {
			return this._isLoading();
		}

		/** @return {boolean} */

	}, {
		key: "isOpened",
		get: function get() {
			return this._isOpened();
		}

		/** @return {boolean} */

	}, {
		key: "isClosed",
		get: function get() {
			return this._isClosed();
		}

		/** @return {boolean} */

	}, {
		key: "isHidden",
		get: function get() {
			return this._isHidden();
		}

		/** @return {boolean} */

	}, {
		key: "isModal",
		get: function get() {
			return this._isModal();
		}

		/** @return {boolean} */

	}, {
		key: "isCloseBtnVisible",
		get: function get() {
			return this._isCloseBtnVisible();
		}

		/** @type {boolean} */

	}, {
		key: "isFullScreen",
		get: function get() {
			return this._o.fullscreen;
		}

		/** @type {boolean} */

	}, {
		key: "isAutoHeight",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_5__utils_var__["d" /* asString */])(this.height) === '' || this.height === 'auto';
		}

		/** @return {*} */

	}, {
		key: "result",
		get: function get() {
			return this._result;
		}

		/**
   * @param {*} value
   */
		,
		set: function set(value) {
			this._result = value;
		}

		/**
   * @return {*}
   */

	}, {
		key: "customData",
		get: function get() {
			return this._o.custom;
		}

		/**
   * @return {string}
   */

	}, {
		key: "cssClass",
		get: function get() {
			return Object(__WEBPACK_IMPORTED_MODULE_5__utils_var__["d" /* asString */])(this._o.cssClass);
		}
	}]);

	return ZDialog;
}();

ZDialog.defaults = {
	name: '',
	type: 'iframe', // iframe, html
	content: '',
	title: '',
	buttons: [],
	modal: false,
	autoOpen: false,
	showCloseButton: false,

	width: '',
	height: '',
	fullscreen: false,
	cssClass: '',

	custom: null,

	//events
	onOpen: null,
	onClose: null
};

var DialogManager = function () {
	/** @type {KnockoutObservableArray<ZDialog>} */
	function DialogManager() {
		var _this5 = this;

		_classCallCheck(this, DialogManager);

		this._counter = 0;
		this._dialogs = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observableArray([]);
		this._isClosing = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.observable(false);
		this._initialized = false;
		this._wrapper = new WindowWrapper();

		this._$html = $('html');
		this._$body = $('body');

		this._isLoading = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.pureComputed(function () {
			return __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.any(_this5.dialogs, function (d) {
				return d.isLoading;
			});
		});

		this._visibleDialogs = __WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.pureComputed(function () {
			return _this5.dialogs.filter(function (d) {
				return !d.isHidden;
			});
		});
	}

	/**
  * @param {ZDialog} dialog
  */


	_createClass(DialogManager, [{
		key: "register",
		value: function register(dialog) {
			if (this.isRegistered(dialog)) {
				return;
			}

			this._dialogs.push(dialog);
			this._checkMarkupAfterOpen();
		}

		/**
   * @param {ZDialog} dialog
   */

	}, {
		key: "unregister",
		value: function unregister(dialog) {
			if (this._dialogs.remove(dialog).length === 0) {
				// nothing has been removed
				return;
			}
			this._checkMarkupAfterClose();
		}

		/**
   * @param {ZDialog} dialog
   */

	}, {
		key: "hide",
		value: function hide(dialog) {
			if (this.isRegistered(dialog)) {
				this._checkMarkupAfterClose();
			}
		}

		/**
   * @param {ZDialog} dialog
   */

	}, {
		key: "show",
		value: function show(dialog) {
			if (this.isRegistered(dialog)) {
				this._checkMarkupAfterOpen();
			}
		}
	}, {
		key: "_checkMarkupAfterOpen",
		value: function _checkMarkupAfterOpen() {
			if (this._isClosing()) {
				clearTimeout(this._timeout);
				this._timeout = null;
				this._isClosing(false);
			} else if (this.visibleDialogs.length === 1 && !this._initialized) {
				this._wrapper.on();

				if (!this._$el) {
					this._$el = $("<div class=\"zdialog-wrapper\" data-bind=\"component: {name: 'zdialog-wrapper', params: $data}, \n\t\t\t\t\t\t\t\t\t\tcss: {'zdialog-loading': isLoading, 'zdialog-closing': isClosing}\"></div>");
					__WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.applyBindings(this, this._$el[0]);
					this._$el.appendTo('body');
				} else {
					this._$el.show();
				}
				this._initialized = true;
			}
		}
	}, {
		key: "_checkMarkupAfterClose",
		value: function _checkMarkupAfterClose() {
			var _this6 = this;

			if (!this._isClosing() && this.visibleDialogs.length === 0 && this._initialized) {
				// no dialogs left
				this._isClosing(true);
				this._timeout = setTimeout(function () {
					_this6._wrapper.off();
					// logger.log('remove container');
					_this6._$el.remove();
					__WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.cleanNode(_this6._$el[0]);
					_this6._$el = null;
					_this6._initialized = false;
					_this6._isClosing(false);
				}, 300);
			}
		}

		/**
   * @param {ZDialog} dialog
   * @return {boolean}
   */

	}, {
		key: "isRegistered",
		value: function isRegistered(dialog) {
			return __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.contains(this.dialogs, dialog);
		}
	}, {
		key: "handleBeforeRemove",
		value: function handleBeforeRemove(node) {
			var $node = $(node);
			$node.remove();
			/*if (node.nodeType === 3) {
   	$node.remove();
   	return;
   }
   $node.addClass('zdialog-closing');
   setTimeout(() => $node.remove(), 300);*/
		}

		/** @return {ZDialog[]} */

	}, {
		key: "getTopmostDialog",
		value: function getTopmostDialog() {
			return __WEBPACK_IMPORTED_MODULE_1_lib_underscore___default.a.last(this.visibleDialogs.filter(function (d) {
				return !d.isLoading;
			}));
		}
	}, {
		key: "isTopmost",
		value: function isTopmost(dialog) {
			return dialog === this.getTopmostDialog();
		}

		/**
   * @param {ZDialog} dialog
   */

	}, {
		key: "getDialogClass",
		value: function getDialogClass(dialog) {
			var css = [];
			if (dialog.isModal) {
				css.push('zdialog-modal');
			}
			if (dialog.isFullScreen) {
				css.push('zdialog-fullscreen');
			}
			if (this.isTopmost(dialog)) {
				css.push('zdialog-topmost');
			} else if (this.visibleDialogs.length > 1) {
				css.push('zdialog-overlapped');
			}
			if (dialog.isLoading) {
				css.push('zdialog-loading');
			}
			if (dialog.isOpened) {
				css.push('zdialog-opened');
			}
			if (dialog.isHidden) {
				css.push('zdialog-hidden');
			}
			if (dialog.name) {
				css.push('zdialog-instance-' + dialog.name);
			}
			if (dialog.cssClass) {
				css.push(dialog.cssClass);
			}
			return css.join(' ');
		}
	}, {
		key: "dialogs",
		get: function get() {
			return this._dialogs();
		}

		/** @return {ZDialog[]} */

	}, {
		key: "visibleDialogs",
		get: function get() {
			return this._visibleDialogs();
		}

		/** @return {boolean} */

	}, {
		key: "isLoading",
		get: function get() {
			return this._isLoading();
		}

		/** @return {boolean} */

	}, {
		key: "isClosing",
		get: function get() {
			return this._isClosing();
		}
	}]);

	return DialogManager;
}();

var HeightWatcher = function () {
	function HeightWatcher($iframe, callback) {
		var _this7 = this;

		_classCallCheck(this, HeightWatcher);

		this._currHeight = 0;
		this._event = $.Callbacks();

		this._event.add(callback);
		this._ibody = $($iframe)[0].contentWindow.document.body;
		// this.updateHeight();
		setTimeout(function () {
			_this7.updateHeight();
			_this7._interval = setInterval(function () {
				return _this7.updateHeight();
			}, 50);
		}, 0);
	}

	_createClass(HeightWatcher, [{
		key: "updateHeight",
		value: function updateHeight() {
			// const newHeight = this._ibody.offsetHeight;
			var newHeight = this.getHeight();
			if (newHeight !== this._currHeight) {
				this._currHeight = newHeight;
				this._event.fire(newHeight);
			}
		}
	}, {
		key: "getHeight",
		value: function getHeight() {
			var height = this._ibody.scrollHeight;
			$(this._ibody).find('iframe:visible').filter(function () {
				return $(this).css('visibility') !== 'hidden';
			}).each(function () {
				var iHeight = $(this).height();
				if (iHeight > height) {
					height = iHeight;
				}
			});
			return height;
		}
	}, {
		key: "off",
		value: function off() {
			clearInterval(this._interval);
			this._event.empty();
		}
	}]);

	return HeightWatcher;
}();

var WindowWrapper = function () {
	function WindowWrapper() {
		_classCallCheck(this, WindowWrapper);

		this._$wnd = $(window);
		this._$html = $('html');
		this._$head = $('head');
		this._scrollTop = 0;
		this._scrollLeft = 0;

		this._$scrollBarStyle = $("<style type=\"text/css\"></style>").appendTo(this._$head);
		this._$positionStyle = $("<style type=\"text/css\"></style>").appendTo(this._$head);
		// this._useFixedLayout = /(iPod|iPhone|iPad)/.test(navigator.userAgent);
		this._useFixedLayout = Object(__WEBPACK_IMPORTED_MODULE_4__utils_utils__["c" /* isMobile */])(); ///(iPod|iPhone|iPad)/.test(navigator.userAgent);
	}

	_createClass(WindowWrapper, [{
		key: "on",
		value: function on() {
			if (this._useFixedLayout) {
				this._scrollTop = this._$wnd.scrollTop();
				this._scrollLeft = this._$wnd.scrollLeft();
				this._applyPositionStyle();
				this._$wnd.scrollTop(0).scrollLeft(0);
			}
			this._applyScrollbarStyle();

			this._$html.toggleClass('zdialog-scrollbar-fix', this._hasScrollBar()).toggleClass('zdialog-position-fix', this._useFixedLayout).addClass('zdialog-open');
		}
	}, {
		key: "off",
		value: function off() {
			this._$html.removeClass('zdialog-scrollbar-fix').removeClass('zdialog-position-fix').removeClass('zdialog-open');
			if (this._useFixedLayout) {
				this._$wnd.scrollTop(this._scrollTop).scrollLeft(this._scrollLeft);
			}
		}
	}, {
		key: "_applyScrollbarStyle",
		value: function _applyScrollbarStyle() {
			var scrollBarWidth = getScrollBarWidth();
			// language=CSS
			this._$scrollBarStyle.html("\n.zdialog-scrollbar-fix {\n\tpadding-right: " + scrollBarWidth + "px;\n}\n");
		}
	}, {
		key: "_applyPositionStyle",
		value: function _applyPositionStyle() {
			// language=CSS
			this._$positionStyle.html("\n.zdialog-position-fix {\n\tposition: fixed;\n\twidth: 100%;\n\theight: 100%;\n\ttop: -" + this._scrollTop + "px;\n\tleft: -" + this._scrollLeft + "px;\n}\n");
		}
	}, {
		key: "_hasScrollBar",
		value: function _hasScrollBar() {
			return hasScrollBar(this._$html);
		}
	}]);

	return WindowWrapper;
}();

function getScrollBarWidth() {
	var $outer = $('<div>').css({ visibility: 'hidden', width: 100, overflow: 'scroll' }).appendTo('body'),
	    widthWithScroll = $('<div>').css({ width: '100%' }).appendTo($outer).outerWidth();
	$outer.remove();
	return 100 - widthWithScroll;
}

function hasScrollBar(el) {
	var $el = $(el);
	return $el.length > 0 ? $el[0].scrollHeight > $(window).height() : false;
}

var dialogManager = new DialogManager();

__WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.components.register('zdialog-wrapper', {
	template: "\n<div class=\"zdialog-overlay\"></div>\n<div class=\"zdialog-loader\"></div>\n<div data-bind=\"foreach: {data: dialogs, beforeRemove: handleBeforeRemove}\">\n\t<div class=\"zdialog-container\">\n\t\t<div class=\"zdialog\" data-bind=\"component: {name: 'zdialog', params: $data}, height: contentHeight, \n\t\t\t\t\t\t\t\t\t\tcss: $parent.getDialogClass($data)\"></div>\n\t</div>\n</div>\n".trim()
});
__WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.components.register('zdialog', {
	template: "\n<div class=\"zdialog-backdrop\" data-bind=\"click: handleBackdropClick\"></div>\n<div class=\"zdialog-content\" data-bind=\"css: 'zdialog-content-' + type, \n\t\t\t\t\t\t\t\t\t\tcomponent: {name: 'zdialog-content-' + type, params: $data},\n\t\t\t\t\t\t\t\t\t\twidth: contentWidth\"></div>\n".trim()
});
__WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.components.register('zdialog-content-iframe', {
	template: "\n<div class=\"zdialog-close-btn\" title=\"\u0417\u0430\u043A\u0440\u044B\u0442\u044C\" data-bind=\"click: handleCloseClick, visible: isCloseBtnVisible, clickBubble: false\"></div>\n<iframe class=\"zdialog-iframe\" frameborder=\"0\" vspace=\"0\" hspace=\"0\" scrolling=\"auto\"\n\t\tdata-bind=\"attr: {src: content}, event: {load: handleIframeLoad}, height: iframeHeight\"></iframe>\n".trim()
});
__WEBPACK_IMPORTED_MODULE_2_lib_knockout___default.a.components.register('zdialog-content-html', {
	template: "\n<!-- ko if: title -->\n<h2 class=\"zdialog-title\">\n\t<span data-bind=\"html: title\"></span>\n\t<div class=\"zdialog-close-btn\" title=\"\u0417\u0430\u043A\u0440\u044B\u0442\u044C\" data-bind=\"click: handleCloseClick, visible: isCloseBtnVisible, clickBubble: false\"></div>\n</h2>\n<!-- /ko -->\n<!-- ko ifnot: title -->\n<div class=\"zdialog-close-btn\" title=\"\u0417\u0430\u043A\u0440\u044B\u0442\u044C\" data-bind=\"click: handleCloseClick, visible: isCloseBtnVisible, clickBubble: false\"></div>\n<!-- /ko -->\n<div class=\"zdialog-html\" data-bind=\"html: content, on: {events: 'click', selector: '[rel=close-dialog]', handler: handleCloseClick}\"></div>\n".trim()
});

/***/ }),

/***/ "i8fT":
/***/ (function(module, exports) {

module.exports = "(function($) {\r\n    $.fn.urlconverter = function(maxlength) {\r\n        return this.each(function() {\r\n            let text = $(this).html();\r\n            if(text) {\r\n                text = text.replace(\"&amp;\", \"&\");\r\n                $(this).html(text.replace(/(https?:\\/\\/)?([\\da-z\\.\\-@]+)\\.([a-z\\.]{2,6})([\\?+=&%#\\/\\wА-Яа-яёЁ\\.;\\-]*)*\\/?/g, function (s) {\r\n                    let st = s;\r\n\r\n                    if (s.length > maxlength) {\r\n                        st = s.slice(0, maxlength) + \"...\";\r\n                    }\r\n\r\n                    if (!/^(https?:\\/\\/)/.test(s)) {\r\n                        if(s.indexOf('@') !== -1) {\r\n                            s = \"mailto:\" + s;\r\n                        } else {\r\n                            s = \"http://\" + s;\r\n                        }\r\n                    }\r\n\r\n                    return \"<a href='\" + s + \"' target='_blank' rel='nofollow noopener'>\" + st + \"</a>\";\r\n                }));\r\n            }\r\n        });\r\n    };\r\n}(jQuery));\r\n"

/***/ }),

/***/ "mvuq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("0iPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 *
 * @param {object} options
 * @return {LastCommentsViewModel}
 */
function init(options) {
    var o = _extends({
        heightTarget: '.layout-content',
        commentsType: 'all',
        reviewType: null
    }, options);

    return new LastCommentsViewModel(o.heightTarget, o.commentsType, o.reviewType);
}

var LastCommentsViewModel = function () {
    function LastCommentsViewModel(heightTarget, commentsType, reviewType) {
        var _this = this;

        _classCallCheck(this, LastCommentsViewModel);

        this._$wrapper = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#commentsWrapper');
        this.needsLoading = true;
        this.allVisible = true;
        this.heightTarget = null;

        var commentsPerPage = 50;

        this.heightTarget = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(heightTarget);

        this._prepareCommentBlocks(this._$wrapper.children('.comment-item'));
        this.fit();

        this._$wrapper.zInfiniteScroll({
            selector: '.comment-item',
            checkViewport: false,
            enabled: function enabled() {
                if (!_this.allVisible) {
                    _this.fit();
                }
                return _this.needsLoading && _this.allVisible;
            },
            maxAutoloadPages: 100,
            loading: '#lastCommentsScrollLoader',
            fetch: function fetch(page, callback) {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get(_this._$wrapper.data('load-url'), {
                    offset: (page - 1) * commentsPerPage,
                    count: commentsPerPage,
                    comments_type: commentsType,
                    review_type: reviewType,
                    new_layout: 1
                }, function (response) {
                    var $blocks = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(response['html']);
                    callback($blocks);
                }, 'json');
            },
            show: function show($blocks) {
                $blocks = $blocks.filter('.comment-item');
                _this.fit();
                _this._$wrapper.append($blocks);
                _this._prepareCommentBlocks($blocks);
                _this.fit();
                return $blocks.length;
            }
        });

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('heightTargetUpdated', function () {
            _this.fit();
        });
    }

    _createClass(LastCommentsViewModel, [{
        key: '_prepareCommentBlocks',
        value: function _prepareCommentBlocks($blocks) {
            $blocks.each(function () {
                var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
                $this.data('height', $this.outerHeight(true));
            });
        }
    }, {
        key: 'fit',
        value: function fit() {
            var $content = this.heightTarget;
            var $comments = this._$wrapper.children('.comment-item');

            var contentBottom = $content.offset().top + $content.outerHeight();
            var top = this._$wrapper.offset().top;
            var commentsBottom = top + this._$wrapper.outerHeight();
            var $item = void 0;
            var result = 0;

            var commentsHeight = this._$wrapper.outerHeight();

            if (commentsBottom > contentBottom) {
                // hide elements one by one while comments column is longer
                do {
                    $item = $comments.filter(':visible').last();
                    if ($item.length === 0) {
                        break;
                    }
                    if (top + commentsHeight > contentBottom) {
                        commentsHeight -= $item.data('height');
                        $item.hide();
                        result--;
                    } else {
                        break;
                    }
                } while (true);
            } else if (commentsBottom < contentBottom) {
                // show elements one by one while comments column is shorter
                do {
                    $item = $comments.filter(':hidden').first();
                    if ($item.length === 0) {
                        break;
                    }
                    commentsHeight += $item.data('height');
                    if (top + commentsHeight <= contentBottom) {
                        $item.show();
                        result++;
                    } else {
                        break;
                    }
                } while (true);
            }

            this.needsLoading = result >= 0;
            this.allVisible = $comments.filter(':hidden').length === 0;
            return result;
        }
    }]);

    return LastCommentsViewModel;
}();

/***/ }),

/***/ "oHD7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GlobalEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_event__ = __webpack_require__("49+S");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 * This class contains different system-wide events as static properties
 */
var GlobalEvents = function GlobalEvents() {
  _classCallCheck(this, GlobalEvents);
};
GlobalEvents.USER_LOGGED_IN = new __WEBPACK_IMPORTED_MODULE_0__utils_event__["a" /* GlobalEvent */]('USER_LOGGED_IN');

/***/ }),

/***/ "oN+n":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
module.exports = function(src) {
	function log(error) {
		(typeof console !== "undefined")
		&& (console.error || console.log)("[Script Loader]", error);
	}

	// Check for IE =< 8
	function isIE() {
		return typeof attachEvent !== "undefined" && typeof addEventListener === "undefined";
	}

	try {
		if (typeof execScript !== "undefined" && isIE()) {
			execScript(src);
		} else if (typeof eval !== "undefined") {
			eval.call(null, src);
		} else {
			log("EvalError: No eval function available");
		}
	} catch (error) {
		log(error);
	}
}


/***/ }),

/***/ "og09":
/***/ (function(module, exports) {

module.exports = toastr;

/***/ }),

/***/ "otQ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReviewList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("0iPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_knockout__ = __webpack_require__("7fPx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lib_knockout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reviewitem__ = __webpack_require__("/ryK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_modals__ = __webpack_require__("YdFU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_utils_url__ = __webpack_require__("FYi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_widgets_notifier__ = __webpack_require__("2uje");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lib_zinfinitescroll__ = __webpack_require__("wC9f");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }









var ReviewList = function () {
	function ReviewList(data) {
		_classCallCheck(this, ReviewList);

		this.reviews = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observableArray([]);
		this.users = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observableArray([]);
		this.reviewCols = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observableArray([]);
		this.colIndex = 0;
		this._filters = null;
		this._infScroll = null;
		this._page = 0;
		this._loading = __WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observable(false);
		this._xhr = null;
		this._onLoad = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.Callbacks();
		this._totalCount = null;
		this._averageRating = null;

		var o = this._o = _extends({
			/**
    * Wrapper element to enable infinite scroll plugin
    */
			infScrollWrapper: null,
			/**
    * Infinite scroll plugin distance parameter
    */
			infScrollDistance: 2000,
			/**
    * Render in columns or linear
    */
			columns: true,
			columnsCount: 5,
			/**
   * Calculate average rating on server
    */
			calculateAverageRating: false,
			/**
    * Show images
    */
			showImages: true,
			/**
    * Show videos
    */
			showVideos: false,
			/**
   * Single review/question details
    */
			isDetails: false,
			/**
    *  Include sales into list
    */
			includeSales: false

		}, data);

		for (var i = 0; i < o.columnsCount; i++) {
			this.reviewCols.push(__WEBPACK_IMPORTED_MODULE_1_lib_knockout___default.a.observableArray([]));
		}

		if (o.infScrollWrapper) {
			this._initInfScroll();
		}

		this._handleItemClick = this._handleItemClick.bind(this);
	}

	/**
  * Render as columns
  * @return {boolean}
  */


	/** @type {InfiniteScroll} */


	_createClass(ReviewList, [{
		key: "load",


		/**
   * Loads reviews from server with given filters
   * @param {object} filters
   * @return {JQuery.jqXHR}
   */
		value: function load(filters) {
			var _this = this;

			this.clear();
			this._filters = filters;
			return this._loadReviews().done(function (response) {
				_this._totalCount = response.totalCount;
				if (response.averageRating !== undefined) {
					_this._averageRating = response.averageRating;
				}
				setTimeout(function () {
					if (_this._infScroll) {
						_this._infScroll.on();
					}
				});
			});
		}

		/**
  * Sets reviews from array
   * @param {array} reviews
  * @param {number} totalCount
   */

	}, {
		key: "loadFromArray",
		value: function loadFromArray(reviews) {
			var _this2 = this;

			var totalCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
			var filters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			this.clear();
			this._page = 1;

			// Model updates data internally so deep copy of data is created
			var reviewsCopy = [];
			reviews.forEach(function (review) {
				return reviewsCopy.push(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(true, {}, review));
			});

			var reviewItems = this._addItems(reviewsCopy);

			var hasMore = false;
			if (totalCount !== null) {
				this._totalCount = totalCount;
				if (totalCount > reviewItems.length) {
					hasMore = true;
				}
			}

			if (filters !== null) {
				this._filters = filters;
			}

			setTimeout(function () {
				return _this2._onLoad.fireWith(_this2, [reviewItems]);
			});

			if (hasMore && this._infScroll) {
				setTimeout(function () {
					return _this2._infScroll.on();
				});
			}
		}

		/**
   * Clears everything
   */

	}, {
		key: "clear",
		value: function clear() {
			var _this3 = this;

			this.reviews().forEach(function (item) {
				return item.offClick(_this3._handleItemClick);
			});
			this.reviews([]);
			this.reviewCols().forEach(function (col) {
				return col([]);
			});
			if (this._infScroll) {
				this._infScroll.off();
			}
			this.colIndex = 0;
			this._page = 0;
			this._filters = null;
			this._loading(false);
			if (this._xhr) {
				this._xhr.abort();
			}
		}
	}, {
		key: "enableSizWatcher",
		value: function enableSizWatcher() {
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('resize', function () {
				ReviewList._reviewSizeSpot(true);
			});
			this.onLoad(ReviewList._reviewSizeSpot);
		}
	}, {
		key: "onLoad",
		value: function onLoad(handler) {
			this._onLoad.add(handler);
		}
	}, {
		key: "offLoad",
		value: function offLoad(handler) {
			this._onLoad.remove(handler);
		}

		/**
  * @param {ReviewItem} item
   */

	}, {
		key: "deleteItem",
		value: function deleteItem(item) {
			var _this4 = this;

			__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post(Object(__WEBPACK_IMPORTED_MODULE_4_core_utils_url__["g" /* siteUrl */])('reviews/delete_review'), { id: item.id }, function (response) {
				if (response.success) {
					if (_this4.container !== null) {
						if (_this4._o.columns) {
							for (var i = 0; i < _this4.reviewCols().length; i++) {
								_this4.reviewCols()[i].remove(item);
							}
						}
						_this4.reviews.remove(item);
					}
				} else {
					__WEBPACK_IMPORTED_MODULE_5__core_widgets_notifier__["a" /* Notifier */].error('Ошибка');
				}
			}, 'json');
		}

		/**
   * @param {object} data
   * @return {ReviewItem}
   */

	}, {
		key: "prependDataItem",
		value: function prependDataItem(data) {
			var item = this._prepareItems([data])[0];

			if (this.container !== null) {
				if (this._o.columns) {
					this.reviewCols()[0]().unshift(item);
				}
				this.reviews.unshift(item);
			}
			this._totalCount++;

			return item;
		}
	}, {
		key: "_initInfScroll",
		value: function _initInfScroll() {
			var _this5 = this;

			this._infScroll = new __WEBPACK_IMPORTED_MODULE_6_lib_zinfinitescroll__["a" /* InfiniteScroll */](this._o.infScrollWrapper, {
				distance: this._o.infScrollDistance,
				onNeedMore: function onNeedMore(callback) {
					if (!_this5._loading()) {
						_this5._loadReviews(callback);
					}
				}
			});
		}

		/**
   *
   * @return {JQuery.jqXHR}
   * @private
   */

	}, {
		key: "_loadReviews",
		value: function _loadReviews() {
			var _this6 = this;

			var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

			this._loading(true);
			return this._xhr = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get(Object(__WEBPACK_IMPORTED_MODULE_4_core_utils_url__["g" /* siteUrl */])('reviews/get_ajax'), _extends({}, this._filters, {
				page: ++this._page,
				calculate_average_rating: this._o.calculateAverageRating ? 1 : 0,
				include_sales: this._o.includeSales ? 1 : 0
			}), null, 'json').always(function () {
				_this6._loading(false);
				_this6._xhr = null;
				if (callback) {
					callback();
				}
			}).done(function (response) {
				var reviewItems = _this6._addItems(response.reviews);
				setTimeout(function () {
					return _this6._onLoad.fireWith(_this6, [reviewItems]);
				});
				if (!response.hasMore && _this6._infScroll) {
					_this6._infScroll.off();
				}
			});
		}

		/**
   * @param {array} items
  * @return {array}
   * @private
   */

	}, {
		key: "_prepareItems",
		value: function _prepareItems(items) {
			var _this7 = this;

			return items.map(function (r) {
				r.parent = _this7;
				return new __WEBPACK_IMPORTED_MODULE_2__reviewitem__["a" /* ReviewItem */](r);
			});
		}

		/**
   * @param {array} items
   * @private
   */

	}, {
		key: "_addItems",
		value: function _addItems(items) {
			var _this8 = this;

			var reviewItems = this._prepareItems(items);
			reviewItems.forEach(function (reviewItem) {
				reviewItem.onClick(_this8._handleItemClick);
			});

			this.reviews.pushAll(reviewItems);

			if (this._o.columns) {
				var reviewCols = [];
				for (var i = 0; i < this._o.columnsCount; ++i) {
					reviewCols.push([]);
				}

				reviewItems.forEach(function (reviewItem) {
					if (_this8.colIndex >= _this8._o.columnsCount) {
						_this8.colIndex = 0;
					}
					reviewCols[_this8.colIndex++].push(reviewItem);
				});

				reviewCols.forEach(function (col, index) {
					if (col.length) {
						_this8.reviewCols()[index].pushAll(col);
					}
				});
			}
			return reviewItems;
		}

		/**
   * @param {ReviewItem} item
   * @private
   */

	}, {
		key: "_handleItemClick",
		value: function _handleItemClick(item) {
			if (!this.isDetails) {
				if (item.data().is_question) {
					window.location = item.data().url;
				} else {
					var index = this.reviews().indexOf(item);
					__WEBPACK_IMPORTED_MODULE_3_core_modals__["MODAL_REVIEW"].show(item.id, index, this._filters);
				}
			}
		}

		/**
  *
   * @param {boolean} reinit
   * @private
   */

	}, {
		key: "columns",
		get: function get() {
			return this._o.columns;
		}

		/**
   * Number of columns
   * @return {int}
   */

	}, {
		key: "columnsCount",
		get: function get() {
			return this._o.columnsCount;
		}

		/**
   * Is loading at the moment
   * @return {boolean}
   */

	}, {
		key: "isLoading",
		get: function get() {
			return this._loading();
		}

		/**
   * Total reviews count
   * @return {int}
   */

	}, {
		key: "totalCount",
		get: function get() {
			return this._totalCount;
		}

		/**
   * Average reviews rating
   * @return {int}
   */

	}, {
		key: "averageRating",
		get: function get() {
			return this._averageRating;
		}

		/**
   * Are images visible
   * @return {boolean}
   */

	}, {
		key: "showImages",
		get: function get() {
			return this._o.showImages;
		}

		/**
   * Are videos visible
   * @return {boolean}
   */

	}, {
		key: "showVideos",
		get: function get() {
			return this._o.showVideos;
		}

		/**
   * Are images visible
   * @return {boolean}
   */

	}, {
		key: "isDetails",
		get: function get() {
			return this._o.isDetails;
		}
	}], [{
		key: "_reviewSizeSpot",
		value: function _reviewSizeSpot() {
			var reinit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

			var $items = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.reviews-wrapper .review-item');
			if (!reinit) {
				$items = $items.not('[size]');
			}
			var width = $items.innerWidth();

			if (width > 240) {
				$items.attr('size', 'large');
			} else if (width <= 240 && width >= 223) {
				$items.attr('size', 'medium');
			} else if (width < 223) {
				$items.attr('size', 'small');
			}
		}
	}]);

	return ReviewList;
}();

/***/ }),

/***/ "qQ5b":
/***/ (function(module, exports) {

module.exports = "<!-- ko if: reviews().length > 0 -->\n<div data-bind=\"foreach: reviews\">\n\t<div class=\"review-list-item\"\n\t    data-bind=\"component: {name: 'review-item-mobile', params: $data}, attr: {id: 'review-list-item-mobile-' + $data.id}\">\n\t</div>\n</div>\n<!-- /ko -->\n<!-- ko else -->\n\t<!-- ko if: !isLoading -->\n\t<div class=\"no-reviews-found\">\n\t\t<div class=\"big\">Извините :(</div>\n\t\t<div class=\"small\">На этот магазин отзывов нет</div>\n\t\t<div class=\"no-reviews-image\">\n\t\t\t<div class=\"img\"></div>\n\t\t</div>\n\t</div>\n\t<!-- /ko -->\n<!-- /ko -->\n"

/***/ }),

/***/ "rItL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = showModalIframe;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("0iPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__url__ = __webpack_require__("FYi7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_dialog__ = __webpack_require__("fokk");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * Shows iframe-based modal window
 * @param {string} name Modal name
 * @param {object} data Custom data to passed as GET parameters
 * @param {object} dialogOptions Options for {@link ZDialog} instance
 * @return {ZDialog}
 */
function showModalIframe(name) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var dialogOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  data = _extends({}, data);
  for (var key in data) {
    if (data[key] === null) delete data[key];
  }var query = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param(_extends({}, data));
  var url = Object(__WEBPACK_IMPORTED_MODULE_1__url__["g" /* siteUrl */])('modals/' + name + (query ? '?' + query : ''));
  return Object(__WEBPACK_IMPORTED_MODULE_2__widgets_dialog__["createIframeDialog"])(url, _extends({ name: name }, dialogOptions, { autoOpen: true }));
}

/***/ }),

/***/ "tXil":
/***/ (function(module, exports) {

var Smart = {};

// Embed the Smart.Plurals source: 


// Create namespace:
if (typeof Smart !== 'object')
	Smart = {};

(function() {

	var rules = {} // Map of language codes to rules
		, defaultCode = null
		, defaultRule = null;

	Smart.Plurals = {
		/**
		 * Retrieves a plural rule, based on the supplied language code.
		 * If no languageCode is specified, the default rule will be returned.
		 *
		 * A plural rule is a function that takes in a value
		 * and determines whether it should be singular form, plural form,
		 * or even other forms, depending on the number of choices.
		 *
		 * @param {String} [languageCode] - Optional - a 2-letter or 4-letter language code, or the full ruleName.
		 * @returns {function({Number} value, {Number|Array} choices)}
		 */
		getRule: function(languageCode) {
			// Calling this with no parameters will return the default:
			if (!languageCode) {
				return defaultRule || (defaultRule = this.getRule(defaultCode));
			}

			// Normalize:
			languageCode = ',' + languageCode.toLowerCase() + ',';

			// Search for an "exact match":
			for (var languageCodes in rules) {
				if (!rules.hasOwnProperty(languageCodes)) continue;

				var isExactMatch = (languageCodes.indexOf(languageCode) !== -1);
				if (isExactMatch) {
					return rules[languageCodes];
				}
			}

			// If we've got a 4-letter code, search for a "generic match" (2-letter code):
			var dash = languageCode.indexOf('-');
			if (dash !== -1) {
				var twoLetterCode = languageCode.substring(1, dash);
				return this.getRule(twoLetterCode);
			}

			return null;
		}
		,
		/**
		 * Sets the default language rule.
		 *
		 * @param {String} languageCode - 2-letter or 4-letter language code
		 */
		setDefaultRule: function(languageCode) {
			defaultCode = languageCode.toLowerCase();
			defaultRule = null; // it's lazy loaded
		}
		,
		/**
		 * Defines a language rule.
		 *
		 * @param {String} languageCodes - A comma-separated list of 2-letter or 4-letter language codes
		 * @param {function({Number} value, {Number} choices)|String} pluralRule - The rule; see getRule for a description.
		 */
		defineRule: function(languageCodes, pluralRule) {
			// Normalize:
			languageCodes = ',' + languageCodes.toLowerCase() + ',';

			var normalizedRule;
			if (typeof pluralRule === 'string') {
				// Allows for aliases
				normalizedRule = this.getRule(pluralRule);
			} else {
				normalizedRule = function (value, choices) {
					if (typeof choices === 'number') {
						return pluralRule(value, choices);
					} else if (typeof choices.length === 'number') {
						return choices[pluralRule(value, choices.length)];
					}
				};
			}

			rules[languageCodes] = normalizedRule;

			if (!defaultCode) {
				this.setDefaultRule(languageCodes.split(',')[1]);
			}

			return normalizedRule;
		}
	};

})();

/**
 * Germanic family
 *  English, German, Dutch, Swedish, Danish, Norwegian, Faroese
 * Romanic family
 *  Spanish, Portuguese, Italian, Bulgarian
 * Latin/Greek family
 *  Greek
 * Finno-Ugric family
 *  Finnish, Estonian
 * Semitic family
 *  Hebrew
 * Artificial
 *  Esperanto
 * Finno-Ugric family
 *  Hungarian
 * Turkic/Altaic family
 *  Turkish
 */
Smart.Plurals.defineRule('english,en,de,nl,sv,da,no,nn,nb,fo,es,pt,it,bg,el,fi,et,he,eo,hu,tr',
	function pluralRule_english(value, choices) {
		// singular used for 1
		// special cases for 0 and negative
		var singular = (value === 1);
		if (choices === 2) return (singular ? 0 : 1);

		var zero = (value === 0);
		if (choices === 3) return (zero ? 0 : singular ? 1 : 2);

		var negative = (value < 0);
		return (negative ? 0 : zero ? 1 : singular ? 2 : 3);
	}
);

/**
 * Slavic family
 *  Czech, Slovak
 */
Smart.Plurals.defineRule('czech,cs,sk', function pluralRule_czech(value, choices) {
	// singular used for 1
	// special case for 2-4
	var singular = (value === 1);
	if (choices === 2) return singular ? 0 : 1;

	var few = (value >= 2 && value <= 4);
	return singular ? 0 : few ? 1 : 2;
});

/**
 * Romanic family
 *  French, Brazilian Portuguese
 */
Smart.Plurals.defineRule('french,fr,pt-br', function pluralRule_french(value, choices) {
	// singular used for 0 and 1
	var singular = (value === 0 || value === 1);
	return (singular ? 0 : 1);
});

/**
 * Celtic
 *  Gaeilge (Irish)
 */
Smart.Plurals.defineRule('irish,ga', function pluralRule_irish(value, choices) {
	// singular used for 1
	// special case for 2
	var singular = (value === 1);
	if (choices === 2) return (singular ? 0 : 1);

	var two = (value === 2);
	return (singular ? 0 : two ? 1 : 2);
});

/**
 * Baltic family
 *  Latvian
 */
Smart.Plurals.defineRule('latvian,lv', function pluralRule_latvian(value, choices) {
	// singular used for 1, 21, 31, 41... -- but not 11, 111, 211, 311, 411...
	// special case for 0
	var singular = (value % 10 === 1 && value % 100 != 11);
	if (choices === 2) return (singular ? 0 : 1);

	var zero = (value === 0);
	return (zero ? 0 : singular ? 1 : 2);
});

/**
 * Baltic family
 *  Lithuanian
 */
Smart.Plurals.defineRule('lithuanian,lt', function pluralRule_lithuanian(value, choices) {
	// singular used for numbers ending in 1 (1, 21, 31, 41...)
	// special case for numbers ending in 12-19 (12-19, 112-119, 212-219...)
	var singular = (value % 10 === 1 && value % 100 != 11);
	if (choices === 2) return singular ? 0 : 1;

	var few = (value % 100 >= 12 && value % 100 <= 19);
	return singular ? 0 : few ? 1 : 2;
});

/**
 * Slavic family
 *  Polish
 */
Smart.Plurals.defineRule('polish,pl', function pluralRule_polish(value, choices) {
	// singular used for 1
	// special case for numbers ending in 2-4, except for 12-14 (2-4, 22-24, 32-34...)
	var singular = (value === 1);
	if (choices === 2) return singular ? 0 : 1;

	var few = (value % 10 >= 2 && value % 10 <= 4 && (value % 100 < 10 || value % 100 >= 20));
	return singular ? 0 : few ? 1 : 2;
});

/**
 * Romanic family
 *  Romanian
 */
Smart.Plurals.defineRule('romanian,ro', function pluralRule_romanian(value, choices) {
	// singular used for 1
	// special case for 0 and numbers ending in 01-19 (0, 2-19, 101-119, 201-219...)
	var singular = (value === 1);
	if (choices === 2) return (singular ? 0 : 1);

	var few = (value === 0 || (value % 100 >= 1 && value % 100 <= 19));
	return (singular ? 0 : few ? 1 : 2);
});

/**
 * Slavic family
 *  Russian, Ukrainian, Serbian, Croatian
 */
Smart.Plurals.defineRule('russian,ru,uk,sr,hr', function pluralRule_russian(value, choices) {
	// singular used for numbers ending in 1, except 11 (1, 21, 31...)
	// special case for numbers ending in 2-4, except 12-14 (2-4, 22-24, 32-34...)
	// numbers ending in 11-14 use plural (11-14, 111-114, 211-214...)
	var singular = (value % 10 === 1 && value % 100 != 11);
	if (choices === 2) return singular ? 0 : 1;

	var few = (value % 10 >= 2 && value % 10 <= 4 && (value % 100 < 10 || value % 100 >= 20));
	return singular ? 0 : few ? 1 : 2;
});

/**
 * Slavic family
 *  Slovenian
 */
Smart.Plurals.defineRule('slovenian,sl', function pluralRule_slovenian(value, choices) {
	// singular used for numbers ending in 01 (1, 101, 201...)
	// special case for numbers ending in 02 (2, 102, 202...)
	// special case for numbers ending in 03-04 (3-4, 103-104, 203-204...)
	var singular = (value % 100 === 1);
	if (choices === 2) return singular ? 0 : 1;

	var two = (value % 100 === 2);
	if (choices === 3) return singular ? 0 : two ? 1 : 2;

	var few = (value % 100 === 3 || value % 100 === 4);
	return singular ? 0 : two ? 1 : few ? 2 : 3;
});


module.exports = Smart;


/***/ }),

/***/ "vBks":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wC9f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfiniteScroll; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("0iPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* Copy-paste of Vadim's extension*/



/**
 * This is simple plugin that checks when window is scrolled
 * to the bottom of the element and fires event in this case
 */
var InfiniteScroll = function () {
	function InfiniteScroll(element, options) {
		_classCallCheck(this, InfiniteScroll);

		this._clNeedMore = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.Callbacks();

		this._$el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element);
		this._$window = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window);
		this._o = _extends({
			/**
    * If distance in pixels between bottom of the window and bottom of the element
    * becomes less than this value - event is fired
    */
			distance: 500,
			/**
    * Event handler
    */
			onNeedMore: null

		}, options);
		if (this._o.onNeedMore) {
			this._clNeedMore.add(this._o.onNeedMore);
		}
	}

	/**
  * Subscribe to needed events and start monitoring
  */


	_createClass(InfiniteScroll, [{
		key: 'on',
		value: function on() {
			if (this._eventHandler) {
				return;
			}
			this._eventHandler = this.update.bind(this);
			this._$window.on('scroll resize', this._eventHandler);
			this.update();
		}

		/**
   * Unsubscribe from all events and stop monitoring
   */

	}, {
		key: 'off',
		value: function off() {
			if (!this._eventHandler) {
				return;
			}
			this._$window.off('scroll resize', this._eventHandler);
			this._eventHandler = null;
		}

		/**
   * Manual update. Event will be fired immediately if needed.
   */

	}, {
		key: 'update',
		value: function update() {
			var checkVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			if (checkVisible && !this._$el.is(':visible')) {
				return;
			}
			var blockEnd = this._$el.offset().top + this._$el.outerHeight();
			var windowHeight = this._$window.height();
			var windowScrollTop = this._$window.scrollTop();
			var isNearBottom = blockEnd < windowScrollTop + windowHeight + this._o.distance;

			if (isNearBottom != this._needMore) {
				this._needMore = isNearBottom;

				if (isNearBottom) {
					this._clNeedMore.fireWith(this._$el[0], [this._loadedMoreCallback.bind(this)]);
				}
			}
		}

		/**
  * Change internal state in response to loaded more event
   */

	}, {
		key: '_loadedMoreCallback',
		value: function _loadedMoreCallback() {
			this._needMore = false;
		}

		/**
   * Add event handler
   * @param callback
   */

	}, {
		key: 'onNeedMore',
		value: function onNeedMore(callback) {
			this._clNeedMore.add(callback);
		}

		/**
   * Remove event handler
   * @param callback
   */

	}, {
		key: 'offNeedMore',
		value: function offNeedMore(callback) {
			this._clNeedMore.remove(callback);
		}
	}]);

	return InfiniteScroll;
}();

__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fn.zInfiniteScroll = function (options) {
	var o = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({
		fetch: null,
		clear: null,
		show: null,
		enabled: null,
		finished: null,
		getCurrentCount: null,
		countPerPage: null,
		totalCount: Number.MAX_VALUE,
		selector: '*',
		btnShowMore: null,
		loading: null,
		maxAutoloadPages: null,
		checkViewport: true,
		autoStart: true
	}, options);

	var $wrapper = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
	var $window = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window);
	var $btnShowMore = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(o.btnShowMore);
	var $loading = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(o.loading);
	var getCurrentCount = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isFunction(o.getCurrentCount) ? o.getCurrentCount : function () {
		return $wrapper.children(o.selector).length;
	};
	var currentPage = o.countPerPage === null ? 1 : function () {
		return getCurrentCount() / o.countPerPage;
	};
	var inProgress = false;
	var isReloading = false;
	var finished = false;
	var t = new Throttler(50);

	$btnShowMore.click(function () {
		$btnShowMore.hide();
		loadMore(function (hasMore) {
			if (hasMore) {
				$btnShowMore.show();
			}
		});
	});

	o.totalCount = +o.totalCount;
	o.maxAutoloadPages = +o.maxAutoloadPages;

	if (o.autoStart) {
		if (getCurrentCount() < o.totalCount) {
			start();
		} else {
			finished = true;
			if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isFunction(o.finished)) {
				o.finished();
			}
		}
	}

	return {
		on: function on() {
			finished = false;
			if (getCurrentCount() < o.totalCount) {
				start();
			} else {
				finished = true;
				if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isFunction(o.finished)) {
					o.finished();
				}
			}
		},
		off: function off() {
			stop();
			finished = true;
		},
		reload: function reload() {
			finished = false;
			if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isFunction(currentPage)) {
				currentPage = 0;
			}
			o.totalCount = Number.MAX_VALUE;

			if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isFunction(o.clear)) {
				o.clear();
			} else {
				$wrapper.children(o.selector).remove();
			}

			if (inProgress) {
				isReloading = true;
			} else {
				loadRoutine();
			}
		}
	};

	function start() {
		if (!finished) {
			$window.on('scroll', onScroll);
		}
	}

	function stop() {
		$window.off('scroll', onScroll);
	}

	function onScroll() {
		if (unwrap(o.enabled) === false || inProgress || !t.ready() || !$wrapper.is(':visible')) {
			return;
		}

		var blockEnd = $wrapper.offset().top + $wrapper.height();
		var windowHeight = $window.height();
		var windowScrollTop = $window.scrollTop();
		var isNearBottom = blockEnd < windowScrollTop + windowHeight + 500;
		var isInViewport = !o.checkViewport || blockEnd > windowScrollTop + 50;
		var ready = isNearBottom && isInViewport;

		if (ready) {
			loadRoutine();
		}
	}

	function loadRoutine() {
		stop();
		loadMore(function () {
			var needMore = getCurrentCount() < o.totalCount;
			if (needMore) {
				if (!o.maxAutoloadPages || unwrap(currentPage) < o.maxAutoloadPages) {
					t.reset();
					start();
				} else {
					$btnShowMore.show();
				}
			} else {
				finished = true;
				if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isFunction(o.finished)) {
					o.finished();
				}
			}
		});
	}

	function loadMore(callback) {
		if (inProgress) {
			return;
		}
		inProgress = true;
		$loading.show();

		o.fetch(unwrap(currentPage) + 1, function ($blocks) {
			if (isReloading) {
				isReloading = false;
				inProgress = false;

				loadRoutine();
				return;
			}
			var count = 0;
			if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isFunction(o.show)) {
				count = o.show($blocks);
			} else {
				$blocks.addClass('fadein');
				$wrapper.append($blocks);
				count = $blocks.length;
			}

			if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isFunction(currentPage)) {
				currentPage++;
			}
			inProgress = false;
			$loading.hide();

			if (count === 0 || o.countPerPage !== null && count < o.countPerPage) {
				// force stop because no more data on server
				o.totalCount = getCurrentCount();
			}

			callback();
		});
	}
};

function unwrap(value) {
	return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isFunction(value) ? value() : value;
}

var Throttler = function () {
	function Throttler(period) {
		_classCallCheck(this, Throttler);

		this.period = +period;
		this.start = +new Date();
	}

	_createClass(Throttler, [{
		key: 'ready',
		value: function ready() {
			var ready = +new Date() - this.start >= this.period;
			if (ready) {
				this.reset();
			}
			return ready;
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.start = +new Date();
		}
	}]);

	return Throttler;
}();

/***/ }),

/***/ "xOlZ":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	autosize 4.0.1
	license: MIT
	http://www.jacklmoore.com/autosize
*/
(function (global, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports !== "undefined") {
		factory(module, exports);
	} else {
		var mod = {
			exports: {}
		};
		factory(mod, mod.exports);
		global.autosize = mod.exports;
	}
})(this, function (module, exports) {
	'use strict';

	var map = typeof Map === "function" ? new Map() : function () {
		var keys = [];
		var values = [];

		return {
			has: function has(key) {
				return keys.indexOf(key) > -1;
			},
			get: function get(key) {
				return values[keys.indexOf(key)];
			},
			set: function set(key, value) {
				if (keys.indexOf(key) === -1) {
					keys.push(key);
					values.push(value);
				}
			},
			delete: function _delete(key) {
				var index = keys.indexOf(key);
				if (index > -1) {
					keys.splice(index, 1);
					values.splice(index, 1);
				}
			}
		};
	}();

	var createEvent = function createEvent(name) {
		return new Event(name, { bubbles: true });
	};
	try {
		new Event('test');
	} catch (e) {
		// IE does not support `new Event()`
		createEvent = function createEvent(name) {
			var evt = document.createEvent('Event');
			evt.initEvent(name, true, false);
			return evt;
		};
	}

	function assign(ta) {
		if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || map.has(ta)) return;

		var heightOffset = null;
		var clientWidth = null;
		var cachedHeight = null;

		function init() {
			var style = window.getComputedStyle(ta, null);

			if (style.resize === 'vertical') {
				ta.style.resize = 'none';
			} else if (style.resize === 'both') {
				ta.style.resize = 'horizontal';
			}

			if (style.boxSizing === 'content-box') {
				heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
			} else {
				heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
			}
			// Fix when a textarea is not on document body and heightOffset is Not a Number
			if (isNaN(heightOffset)) {
				heightOffset = 0;
			}

			update();
		}

		function changeOverflow(value) {
			{
				// Chrome/Safari-specific fix:
				// When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
				// made available by removing the scrollbar. The following forces the necessary text reflow.
				var width = ta.style.width;
				ta.style.width = '0px';
				// Force reflow:
				/* jshint ignore:start */
				ta.offsetWidth;
				/* jshint ignore:end */
				ta.style.width = width;
			}

			ta.style.overflowY = value;
		}

		function getParentOverflows(el) {
			var arr = [];

			while (el && el.parentNode && el.parentNode instanceof Element) {
				if (el.parentNode.scrollTop) {
					arr.push({
						node: el.parentNode,
						scrollTop: el.parentNode.scrollTop
					});
				}
				el = el.parentNode;
			}

			return arr;
		}

		function resize() {
			if (ta.scrollHeight === 0) {
				// If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
				return;
			}

			var overflows = getParentOverflows(ta);
			var docTop = document.documentElement && document.documentElement.scrollTop; // Needed for Mobile IE (ticket #240)

			ta.style.height = '';
			ta.style.height = ta.scrollHeight + heightOffset + 'px';

			// used to check if an update is actually necessary on window.resize
			clientWidth = ta.clientWidth;

			// prevents scroll-position jumping
			overflows.forEach(function (el) {
				el.node.scrollTop = el.scrollTop;
			});

			if (docTop) {
				document.documentElement.scrollTop = docTop;
			}
		}

		function update() {
			resize();

			var styleHeight = Math.round(parseFloat(ta.style.height));
			var computed = window.getComputedStyle(ta, null);

			// Using offsetHeight as a replacement for computed.height in IE, because IE does not account use of border-box
			var actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(computed.height)) : ta.offsetHeight;

			// The actual height not matching the style height (set via the resize method) indicates that 
			// the max-height has been exceeded, in which case the overflow should be allowed.
			if (actualHeight !== styleHeight) {
				if (computed.overflowY === 'hidden') {
					changeOverflow('scroll');
					resize();
					actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
				}
			} else {
				// Normally keep overflow set to hidden, to avoid flash of scrollbar as the textarea expands.
				if (computed.overflowY !== 'hidden') {
					changeOverflow('hidden');
					resize();
					actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
				}
			}

			if (cachedHeight !== actualHeight) {
				cachedHeight = actualHeight;
				var evt = createEvent('autosize:resized');
				try {
					ta.dispatchEvent(evt);
				} catch (err) {
					// Firefox will throw an error on dispatchEvent for a detached element
					// https://bugzilla.mozilla.org/show_bug.cgi?id=889376
				}
			}
		}

		var pageResize = function pageResize() {
			if (ta.clientWidth !== clientWidth) {
				update();
			}
		};

		var destroy = function (style) {
			window.removeEventListener('resize', pageResize, false);
			ta.removeEventListener('input', update, false);
			ta.removeEventListener('keyup', update, false);
			ta.removeEventListener('autosize:destroy', destroy, false);
			ta.removeEventListener('autosize:update', update, false);

			Object.keys(style).forEach(function (key) {
				ta.style[key] = style[key];
			});

			map.delete(ta);
		}.bind(ta, {
			height: ta.style.height,
			resize: ta.style.resize,
			overflowY: ta.style.overflowY,
			overflowX: ta.style.overflowX,
			wordWrap: ta.style.wordWrap
		});

		ta.addEventListener('autosize:destroy', destroy, false);

		// IE9 does not fire onpropertychange or oninput for deletions,
		// so binding to onkeyup to catch most of those events.
		// There is no way that I know of to detect something like 'cut' in IE9.
		if ('onpropertychange' in ta && 'oninput' in ta) {
			ta.addEventListener('keyup', update, false);
		}

		window.addEventListener('resize', pageResize, false);
		ta.addEventListener('input', update, false);
		ta.addEventListener('autosize:update', update, false);
		ta.style.overflowX = 'hidden';
		ta.style.wordWrap = 'break-word';

		map.set(ta, {
			destroy: destroy,
			update: update
		});

		init();
	}

	function destroy(ta) {
		var methods = map.get(ta);
		if (methods) {
			methods.destroy();
		}
	}

	function update(ta) {
		var methods = map.get(ta);
		if (methods) {
			methods.update();
		}
	}

	var autosize = null;

	// Do nothing in Node.js environment and IE8 (or lower)
	if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
		autosize = function autosize(el) {
			return el;
		};
		autosize.destroy = function (el) {
			return el;
		};
		autosize.update = function (el) {
			return el;
		};
	} else {
		autosize = function autosize(el, options) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], function (x) {
					return assign(x, options);
				});
			}
			return el;
		};
		autosize.destroy = function (el) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], destroy);
			}
			return el;
		};
		autosize.update = function (el) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], update);
			}
			return el;
		};
	}

	exports.default = autosize;
	module.exports = exports['default'];
});

/***/ }),

/***/ "yVr+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_components_review_list_adaptive_less__ = __webpack_require__("DgU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_components_review_list_adaptive_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_components_review_list_adaptive_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sidebar__ = __webpack_require__("S/qL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_reviews_common_model_reviewlist__ = __webpack_require__("otQ7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_reviews_common_model_reviewlistmobile__ = __webpack_require__("cK6l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_modals__ = __webpack_require__("YdFU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_reviews_common_components__ = __webpack_require__("+KrN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_auth__ = __webpack_require__("UpRQ");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }










var isQuestionsPage = false;

function init(options) {
    var o = _extends({
        isDetailsPage: false,
        isQuestionsPage: false,
        review: null,
        reviewsFilterArray: [],
        includeSales: false
    }, options);

    isQuestionsPage = o.isQuestionsPage;
    var viewModel = new ViewModel(o.reviewsFilterArray, o.review, o.isDetailsPage, o.isQuestionsPage, o.includeSales);

    __WEBPACK_IMPORTED_MODULE_1__sidebar__["a" /* init */](isQuestionsPage ? 'question' : null);

    initCustomSelect();
    initReviewFilters();
    initSearchAmongReviewsButton();
    initAskQuestionButton(viewModel);

    ko.applyBindings(viewModel, $('#reviewsLayout')[0]);
}

function initCustomSelect() {
    $('#reviews-sort-wrapper').find('select[rel=chosen]').chosen();
}

function initReviewFilters() {
    $(function () {
        var form = $('#reviews-filter-wrapper, #reviews-sort-wrapper');

        $('select, input[type=checkbox], input[type=radio]', form).on('change', function () {
            document.location.href = getLink(form);
        });

        $(form).on('submit', function () {
            return false;
        });

        $('[name=sort_by]').on('change', function () {
            document.location.href = getLink(form);
        });

        $('#reviews-filter-wrapper .btn-show-more').click(function (e) {
            e.preventDefault();
            $(this).prevAll('.parametric-list:first').removeClass('shortened');
        });
    });
}

function initSearchAmongReviewsButton() {
    $('#searchAmongReviewsButton').click(function () {
        return $('#searchPanel').find('input[name=search]').focus();
    });
}

function initAskQuestionButton(viewModel) {
    $('#askQuestionBtn').click(function () {
        Object(__WEBPACK_IMPORTED_MODULE_6_core_auth__["ensureLoggedIn"])(function (user) {
            return __WEBPACK_IMPORTED_MODULE_4__core_modals__["MODAL_QUESTION_EDIT"].show(null, function (response) {
                if (response && response.normalizedData) {
                    viewModel.reviewList.prependDataItem(response.normalizedData);
                    viewModel.reviewListMobile.prependDataItem(response.normalizedData);
                }
            });
        });
    });
}

// Function copied from legacy code
function getLink(form) {
    if ($('[name="source"]', form).val() == 'old') {
        $('[name="with_image"]', form).attr('checked', false).attr('disabled', true);
    } else {
        $('[name="with_image"]', form).attr('disabled', false);
    }
    var link = isQuestionsPage ? 'questions' : 'reviews';
    $('input, select', form).each(function () {
        if (this.tagName == 'SELECT' && $(this).val() != "0" || this.tagName == 'INPUT' && $(this).is(':checked')) {
            if ($(this).attr('name') == 'shop') {
                if ($(this).data('value') != 'all') {
                    link += '/' + 's_' + $(this).data('value');
                }
            } else if ($(this).attr('name') == 'category') {
                if ($(this).data('value') != 'all') {
                    link += '/' + 'c_' + $(this).data('value');
                }
            } else if ($(this).attr('name') == 'package_group') {
                if ($(this).data('value') != 'all') {
                    link += '/' + 'pg_' + $(this).data('value');
                }
            } else if ($(this).attr('name') == 'comment_count') {
                if ($(this).data('value') != '0') {
                    link += '/' + 'cc_' + $(this).data('value');
                }
            } else if ($(this).attr('name') == 'source') {
                if ($(this).val() != '0') {
                    link += '/' + 'src_' + $(this).val();
                }
            } else if ($(this).attr('name') == 'course') {
                if ($(this).val() != 'down') {
                    link += '/' + 'cr_' + $(this).val();
                }
            } else if ($(this).attr('name') == 'mine') {
                if ($(this).val() == 'on') {
                    link += '/' + 'mine';
                }
            } else if ($(this).attr('name') == 'forsale') {
                if ($(this).val() == 'on') {
                    link += '/' + 'forsale';
                }
            } else if ($(this).attr('name') == 'with_image') {
                switch ($(this).data('value')) {
                    case 'custom':
                        link += '/' + 'img_custom';
                        break;
                    case 'off':
                        link += '/' + 'img_off';
                        break;
                }
            } else if ($(this).attr('name') == 'period') {
                if ($(this).data('value') != 'all') {
                    link += '/' + 'p_' + $(this).data('value');
                }
            } else {
                link += '/' + $(this).attr('name') + '/' + $(this).val();
            }
        }
    });

    var search_val = $.trim($('[rel=search-input]').val());
    var has_search = search_val.length > 0;

    if ($("[name=sort_by]").val() !== undefined) {
        var sort_by = $("[name=sort_by]").val();
        if (has_search) {
            if (sort_by != 'default_search') {
                link += '/' + 'sb_' + sort_by;
            }
        } else {
            if (sort_by == "default_search") sort_by = "update_date";
            if (sort_by != 'update_date') {
                link += '/' + 'sb_' + sort_by;
            }
        }
    }

    if (has_search) {
        link += '?search=' + search_val;
    }

    $('[class=filter-link]', form).attr('href', link);
    return link;
}

var ViewModel =
/** @type {ReviewList} */
function ViewModel(reviewsFilterArray, review, isDetailsPage, isQuestionsPage, includeSales) {
    _classCallCheck(this, ViewModel);

    this.reviewList = null;
    this.reviewListMobile = null;

    this.reviewList = new __WEBPACK_IMPORTED_MODULE_2_modules_reviews_common_model_reviewlist__["a" /* ReviewList */]({
        infScrollWrapper: $('.review-columns'),
        columns: !isQuestionsPage,
        columnsCount: 4,
        calculateAverageRating: false,
        showImages: !isQuestionsPage,
        showVideos: isQuestionsPage,
        isDetails: isDetailsPage,
        includeSales: includeSales
    });
    this.reviewListMobile = new __WEBPACK_IMPORTED_MODULE_3_modules_reviews_common_model_reviewlistmobile__["a" /* ReviewListMobile */]({
        infScrollWrapper: $('.review-rows'),
        calculateAverageRating: false,
        showImages: !isQuestionsPage,
        showVideos: isQuestionsPage,
        isDetails: isDetailsPage
    });
    this.reviewList.enableSizWatcher();

    if (review === null) {
        // Load from server
        this.reviewList.load(reviewsFilterArray);
        this.reviewListMobile.load(reviewsFilterArray);
    } else {
        // Load data passed through reviews parameter
        this.reviewList.loadFromArray([review]);
        this.reviewListMobile.loadFromArray([review]);
    }
}
/** @type {ReviewListMobile} */
;

/***/ })

},[10]);


// WEBPACK FOOTER //
// reviews.min.js